<template>
    <base-page>
        <CustomTable
            class=""
            :module-name="moduleName"
            :module-name-singular="moduleNameSingular"
            :response="response"
            :isLoading="isLoading"
            :tableHeaders="tableHeaders"
            :filters="companyFilters"
            :bulkOperations="companyBulkOperations"
            :summaryActions="companySummaryActions"
            :menuOptions="menuOptions"
            :defaultOrdering="defaultOrdering"
            :selectedResultFields="selectedResultFields"
            :shouldReload="shouldReload"
            :shouldClearSelected="shouldClearSelected"
            :bulkOperationResponse="bulkOperationResponse"
            :reorder-bulk-operations="reorderBulkOperations"
            :reorder-filters="reorderFilters"
            :summary-button-reset-id="summaryActionButtonId"
            createModalSize="w-3/4 h-5/6"
            @refetch-results="loadCompanies"
            @clear-filter="clearFilter"
            @clear-all-active-filters="clearAllActiveFilters"
            @change-filters="setFilters"
            @set-filter-options="setFilterOptions"
            @perform-bulk-action="performCompanyBulkAction"
            @perform-summary-action="performSummaryAction"
            @clear-summary-action-data="clearSummaryActionData"
            @toggle-pinned-filter="togglePinnedFilter"
            @save-filter-order="saveFilterOrder"
            @save-bulk-operation-order="saveBulkOperationOrder"
            @toggle-pinned-bulk-operation="togglePinnedBulkOperation"
            @handle-bulk-operation-input-change="handleBulkOperationInputChange"
            @export-to-csv="exportResultsToCSV"
        >
            <template #create-form="{ events: { closeCreateForm, refetchResults }, fetchFilter }">
                <CreateCompany
                    :client-options="clientOptions"
                    @refetch-results="refetchResults(fetchFilter)"
                    @close="closeCreateForm"
                />
            </template>
            <template #table-row="{ events: { addSelectedResult, removeSelectedResult, refetchResults, openRowDetails }, selectAll, expandAll, fetchFilter, userPermissions, results, clearedSelectedResults, selectedResults }">
                <CompanyRow
                    v-for="company in results"
                    :key="company.id"
                    :selectAll="selectAll"
                    :expandAll="expandAll"
                    :userPermissions="userPermissions"
                    :clearedSelectedResults="clearedSelectedResults"
                    :company="company"
                    :crm-status-options="crmStatusOptions"
                    :selected-results="selectedResults"
                    :crm-next-action-options="crmNextActionOption"
                    :crm-users="crmUsers"
                    :resetToPreviousCRMAction="resetToPreviousCRMAction"
                    :action-button-reset-id="actionButtonId"
                    @refetch-results="refetchResults(fetchFilter)"
                    @select-row="addSelectedResult"
                    @deselect-row="removeSelectedResult"
                    @open-row-details="openRowDetails"
                    @perform-row-action="performRowAction"
                />
                <tr class="bg-gray-200 h-80">
                    <td :colspan="columnSpan" :class="{ 'border-t border-gray-300' : results && results.length > 0}"></td>
                </tr>
            </template>
            <!-- <template #details-page="{ events: { closeDetails, refetchResults }, resultRow, userPermissions, fetchFilter }">
                <CompanyDetails
                    :company="resultRow"
                    :user-permissions="userPermissions"
                    :client-options="clientOptions"
                    @close-details="closeDetails"
                    @refetch-results="refetchResults(fetchFilter)"
                />
            </template> -->
            <template #table-footer="{ events: { getNext, goToFirst, getPrev, goToLast, jumpToPage, setPageSizeFilter, setExactCount }, viewingFromNbr, viewingToNbr, count, selectedResults, totalPages, countIsCapped, isPastEnd, exactCount, page, results, next, prev }">
                <CompanyFooter
                    :is-loading="isLoading"
                    :viewingFromNbr="viewingFromNbr"
                    :viewingToNbr="viewingToNbr"
                    :count="count"
                    :selectedResults="selectedResults"
                    :numPages="totalPages"
                    :count-is-capped="countIsCapped"
                    :is-past-end="isPastEnd"
                    :exact-count="exactCount"
                    :results="results"
                    :page="page"
                    :column-span="columnSpan"
                    :has-next="next"
                    :has-prev="prev"
                    @get-next="getNext"
                    @go-to-first="goToFirst"
                    @get-prev="getPrev"
                    @go-to-last="goToLast"
                    @jump-to-page="jumpToPage"
                    @set-page-size-filter="setPageSizeFilter"
                    @set-exact-count="setExactCount"
                />
            </template>
        </CustomTable>
        <InfoModal
            :is-modal-visible="visibleContactList"
            @close="closeContactList"
        >
            <template #header>
                All Contacts
            </template>
            <template #body>
                <AllContactsList :company="displayedCompany" @refetch-companies="reloadCompanies" @close="closeContactList" />
            </template>
        </InfoModal>
        <InfoModal
            :is-modal-visible="visibleNewContactForm"
            @close="closeNewContactForm"
        >
            <template #header>
                Add Contact
            </template>
            <template #body>
                <CompanyContactFormVertical
                    :company="displayedCompany"
                    @refetch-companies="reloadCompanies"
                    @close-form="closeNewContactForm"
                />
            </template>
        </InfoModal>
        <base-modal-small v-if="visibleCRMEventForm" @close="closeCRMEventFormWithoutSaving">
          <template #header>
            <h2 class="text-lg">{{ displayedCompany.company_name }} {{ displayedCompany.id }} - Change CRM Next Action</h2>
          </template>
          <template #body>
            <div class="w-full p-1 h-[90%] overflow-auto">
                <div class="w-full flex flex-col pt-4">
                    <form action="" id="eventsForm" @submit.prevent="saveCRMNextActionWithEvent"></form>  
                    <div class="flex w-full px-3 pb-2">
                        <div class="flex w-full items-center text-sm tracking-wide text-gray-800">
                            Updating Next Action from<span class="font-semibold px-1">{{ previousAction }}</span>to<span class="font-semibold pl-1">{{ crmNextAction }}</span>.
                        </div>
                    </div>
                    <div class="flex w-full items-center px-3 pb-2">
                        <label class="h-8 w-1/4 flex items-center px-2 py-1 bg-gray-100 rounded-l border border-r-0 border-gray-300" for="" >
                            Due Date:
                        </label>
                        <input :required="crmNextAction != 'None'" form="eventsForm" v-model="crmNextActionDueDate" id="crmNextActionDueDate" type="date"
                            class="h-8 text-center p-1 border w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block "
                        >
                    </div>
                    <div class="w-full flex items-center px-3 pb-4 border-b">
                        <div class="w-1/4"></div>
                        <div class="w-full gap-1.5 grid grid-cols-4 xl:grid-cols-8">
                            <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNextActionDueDate(null)">Today</button>
                            <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNextActionDueDate(3)">+3d</button>
                            <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNextActionDueDate(7)">+1w</button>
                            <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNextActionDueDate(14)">+2w</button>
                            <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNextActionDueDate(21)">+3w</button>
                            <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNextActionDueDate(30)">+1m</button>
                            <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNextActionDueDate(60)">+2m</button>
                            <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNextActionDueDate(90)">+3m</button>
                        </div>
                    </div>
                    <div class="w-full px-3 flex justify-between items-center py-2">
                        <div class="text-sm tracking-wide text-gray-800">
                            Was the previous action<span class="font-semibold px-1">{{ previousAction }}</span>completed?
                        </div>
                        <div class="flex items-center justify-center">
                            <div class="flex items-center m-1">
                                <div class="mr-1">
                                    Yes
                                </div>
                                <input type="radio" class="accent-dark-secondary" name="completedAction" :value="true" v-model="completedAction">
                            </div>
                            <div class="flex items-center m-1">
                                <div class="mr-1">
                                    No
                                </div>
                                <input type="radio" class="accent-dark-secondary" name="completedAction" :value="false" v-model="completedAction">
                            </div>                  
                        </div>
                    </div>
                    <transition
                        enter-active-class="transition duration-150 ease-out"
                        enter-from-class="transform origin-top scale-0"
                        enter-to-class="transform origin-top scale-1"
                        leave-active-class="transition duration-100 ease-in"
                        leave-from-class="transform origin-top scale-1"
                        leave-to-class="transform origin-top scale-0"
                    >
                        <div v-if="completedAction" class="transition duration-300 ease-in-out px-1 py-2 mb-2 flex flex-col border-b">
                            <div class="w-full flex flex-col items-start space-y-2 px-2">
                                <div class="w-full flex justify-start tracking-wide text-gray-800">
                                    Add a CRM Detail here documenting the action for reporting purposes.
                                </div>
                                <div class="w-full flex items-center">
                                    <label class="h-8 w-1/4 flex items-center px-2 py-1 bg-gray-100 rounded-l border border-r-0 border-gray-300" for="" >
                                        Detail Name:
                                    </label>
                                    <select required form="eventsForm" v-model="crmDetailData.action_id" class="h-8 text-center p-1 border w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block " name="" id="">
                                        <!-- <option value="">------</option> -->
                                        <option v-for="event in crmActionTypes" :key=event.id :value="event.id">{{ event.action_name }}</option>
                                    </select>
                                </div>
                                <div class="w-full flex items-center">
                                    <label class="h-8 w-1/4 flex items-center px-2 py-1 bg-gray-100 rounded-l border border-r-0 border-gray-300" for="" >
                                        Resolved Date:
                                    </label>
                                    <input  required form="eventsForm" v-model="crmDetailData.resolved_date" id="crmNewActionDueDate" type="date"
                                        class="h-8 text-center p-1 border w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block "
                                    >
                                </div>
                                <div class="w-full flex items-center">
                                    <div class="w-1/4"></div>
                                    <div class="w-full gap-1.5 grid grid-cols-4 xl:grid-cols-8">
                                        <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setCRMDetailResolvedDate(null)">Today</button>
                                        <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setCRMDetailResolvedDate(3)">+3d</button>
                                        <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setCRMDetailResolvedDate(7)">+1w</button>
                                        <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setCRMDetailResolvedDate(14)">+2w</button>
                                        <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setCRMDetailResolvedDate(21)">+3w</button>
                                        <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setCRMDetailResolvedDate(30)">+1m</button>
                                        <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setCRMDetailResolvedDate(60)">+2m</button>
                                        <button class="w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setCRMDetailResolvedDate(90)">+3m</button>
                                    </div>
                                </div>
                                <div class="w-full flex items-center">
                                    <label class="h-8 w-1/4 flex items-center px-2 py-1 bg-gray-100 rounded-l border border-r-0 border-gray-300" for="" >
                                        User:
                                    </label>
                                    <select v-model="crmDetailData.user_id" id="crmNewActionUser"
                                        class="h-8 p-1 border text-center w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block "
                                        >
                                        <option value="">---User---</option>
                                        <option v-for="user in crmUsers" :key="user.id" :value="user.id">{{ user.first_name}} {{ user.last_name }}</option>
                                    </select>
                                </div>
                                <div class="w-full flex items-center">
                                    <textarea v-model="crmDetailData.action_notes" id="notesInput" type="text" rows="3" placeholder="Notes"
                                        class=" col-span-4 p-1 border w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block "
                                    ></textarea>
                                </div>
                                <div class="w-full flex justify-center items-center space-x-4">
                                </div>
                            </div>
                        </div>
                    </transition>
                    <div class="w-full px-3 flex justify-between items-center mb-2">
                        <div class="text-sm tracking-wide text-gray-800">
                            Would you like to make a new CRM Detail for<span class="font-semibold pl-1">{{ crmNextAction }}</span>?
                        </div>
                        <div class="flex items-center justify-center">
                            <div class="flex items-center m-1">
                                <div class="mr-1">
                                    Yes
                                </div>
                                <input type="radio" class="accent-dark-secondary" name="newDetail" :value="true" v-model="newDetail">
                            </div>
                            <div class="flex items-center m-1">
                                <div class="mr-1">
                                    No
                                </div>
                                <input type="radio" class="accent-dark-secondary" name="newDetail" :value="false" v-model="newDetail">
                            </div>                    
                        </div>
                    </div>
                    <transition
                    enter-active-class="transition duration-150 ease-out"
                    enter-from-class="transform origin-top scale-0"
                    enter-to-class="transform origin-top scale-1"
                    leave-active-class="transition duration-100 ease-in"
                    leave-from-class="transform origin-top scale-1"
                    leave-to-class="transform origin-top scale-0"
                    >
                        <div v-if="newDetail" class="transition duration-300 ease-in-out px-1 py-2 flex flex-col border-b">
                            <div class="w-full flex flex-col items-start space-y-2 px-2">
                                <div class="w-full flex justify-start tracking-wide text-gray-800">
                                    Add a CRM Detail here for the next action.
                                </div>
                                <div class="w-full flex items-center">
                                    <label class="h-8 w-1/4 flex items-center px-2 py-1 bg-gray-100 rounded-l border border-r-0 border-gray-300" for="" >
                                        Detail Name:
                                    </label>
                                    <select required form="eventsForm" v-model="newDetailFormData.action_id" class="h-8  text-center p-1 border w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block " name="" id="">
                                        <option v-for="event in crmActionTypes" :key=event.id :value="event.id">{{ event.action_name }}</option>
                                    </select>
                                </div>
                                <div class="w-full flex items-center">
                                    <label class="h-8 w-1/4 flex items-center px-2 py-1 bg-gray-100 rounded-l border border-r-0 border-gray-300" for="" >
                                        Due Date:
                                    </label>
                                    <input v-model="newDetailFormData.due_date" type="date"
                                        class="h-8 text-center p-1 border w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block "
                                    >
                                </div>
                                <div class="w-full flex items-center">
                                    <div class="w-1/4"></div>
                                    <div class="w-full gap-1.5 grid grid-cols-4 xl:grid-cols-8">
                                        <button class=" w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNewDetailFormDueDate(null)">Today</button>
                                        <button class=" w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNewDetailFormDueDate(3)">+3d</button>
                                        <button class=" w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNewDetailFormDueDate(7)">+1w</button>
                                        <button class=" w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNewDetailFormDueDate(14)">+2w</button>
                                        <button class=" w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNewDetailFormDueDate(21)">+3w</button>
                                        <button class=" w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNewDetailFormDueDate(30)">+1m</button>
                                        <button class=" w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNewDetailFormDueDate(60)">+2m</button>
                                        <button class=" w-full h-8 tracking-wide font-medium text-white bg-dark-secondary hover:bg-dark-primary hover:text-gray-100 hover:shadow active:bg-dark-primary active:text-gray-400 rounded-md" @click="setNewDetailFormDueDate(90)">+3m</button>
                                    </div>
                                </div>
                                <div class="w-full flex items-center">
                                    <label class="h-8 w-1/4 flex items-center px-2 py-1 bg-gray-100 rounded-l border border-r-0 border-gray-300" for="" >
                                        User:
                                    </label>
                                    <select v-model="newDetailFormData.user_id"
                                        class="h-8 p-1 border text-center w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block "
                                        >
                                        <option value="">---User---</option>
                                        <option v-for="user in crmUsers" :key="user.id" :value="user.id">{{ user.first_name}} {{ user.last_name }}</option>
                                    </select>
                                </div>
                                <div class="w-full flex items-center">
                                    <textarea v-model="newDetailFormData.action_notes" type="text" rows="3" placeholder="Notes"
                                        class=" col-span-4 p-1 border w-full border-gray-300 text-gray-900 focus:ring-blue-500 focus:border-blue-500 block "
                                    ></textarea>
                                </div>
                                <div class="w-full flex justify-center items-center space-x-4">
                                </div>
                            </div>
                        </div>
                    </transition>

                    <div class="w-full flex justify-center mt-2">
                        <base-button form="eventsForm">Save</base-button>
                    </div>
                </div>
            </div>
          </template>
        </base-modal-small>
        <base-modal :is-form-visible="visibleCRMDetails" @close="closeCRMDetails">
          <template #header>
            <h2 class="text-lg">
              {{ displayedCompany.company_name }} CRM Details
            </h2>
          </template>
          <template #body>
            <CRMDetailsPage 
                :company="displayedCompany" 
                :campaigns="campaigns" 
                :default-campaign="defaultCampaignId"
                :crm-statuses="crmStatuses"
                :crm-action-types="crmActionTypes"
                @updated="closeCRMDetails"
                @refetch-companies="reloadCompanies"
             />
          </template>
        </base-modal>
        <base-modal :is-form-visible="visibleEditForm" @close="closeEditForm">
          <template #header>
            <h2 class="text-lg">{{ displayedCompany.company_name }} {{ displayedCompany.id }}</h2>
          </template>
          <template #body>
            <EditCompany
              :company="displayedCompany"
              :campaigns="campaigns"
              @close="closeEditForm"
              @refetch-companies="reloadCompanies"
            />
          </template>
        </base-modal>
    </base-page>
</template>

<script setup>
import { ref, reactive, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useToast } from 'vue-toast-notification';
import CustomTable from '../base-components/CustomTable.vue';
import CompanyRow from './CompanyRow.vue';
import CompanyFooter from './CompanyFooter.vue';
import CreateCompany from '@/components/CreateCompany.vue';
import EditCompany from '../EditCompany.vue'
import CRMDetailsPage from '../CRMDetailsPage.vue'
import InfoModal from '../InfoModal.vue';
import CompanyContactFormVertical from '../CompanyContactFormVertical.vue';
import AllContactsList from '../company-cell-components/AllContactsList.vue';
import { getClients } from '@/services/Client';
import { getSources } from '@/services/Source';
import { getGeoLocations } from '@/services/GeoLocation';
import { getUsersWithTasks, getUsers } from '@/services/User';
import { getCampaigns } from '@/services/Campaign';
import { getCrmStatuses } from '@/services/CrmStatus';
import { getTiers } from '@/services/Tiers';
import { getCollectionTags } from '@/services/CollectionTag';
import { getNAICSCodes } from '@/services/NAICSCode';
import { getReferralSources } from '@/services/Referrer';
import { getAsynchronousJobQueue } from "@/services/AsynchronousJobs";
import { getActions } from '@/services/CrmAction'
import { getEmailTemplate, getEmailTemplates } from '@/services/EmailTemplates';
import { prepareOutreachDrafts } from '@/services/OutreachDraft';
import { 
    getCompaniesByQueryParams, 
    markTier,
    addNewCrmStatus, 
    getZoomInfoId, 
    getZoomInfoBasic, 
    clearZoomInfo, 
    updateCompany,
    updateCrmNextAction, 
    updateCrmNextActionAndAddEvent, 
    performBulkAction, 
    performBulkActionOnQuery,
    getCRMSummaries,
    getCRMSummaryStageCounts,
    vetURL,
    exportToCSV,
} from '@/services/Company.js';
import { 
    getPinnedUserCompanyFilterFields, 
    setPinnedUserCompanyFilterField,
    getPinnedUserCompanyBulkOperationFields,
    createPinnedUserCompanyBulkOperationField,
    deletePinnedUserCompanyBulkOperationField,
    updateFilterOrdinals,
    updateBulkOperationOrdinals
} from '@/services/PageConfig';
import { createZIUploadCsv } from '@/composables/createCSV.js';
import { formatDateTime } from '@/composables/formatDateTime';
import { getDateAsString, getTodaysDateAsString } from '@/composables/formatDate';
import { createCSV, getCompanyFields } from '@/composables/createCSV';

const store = useStore()
const $toast = useToast()
const completedAction = ref(false)
const newDetail = ref(false)
const isLoading = ref(false)
const moduleName = ref('Companies')
const moduleNameSingular = ref('Company');
const response = ref(null)
const clientOptions = ref([])
const defaultOrdering = ref([])
const shouldReload = ref(false)
const shouldClearSelected = ref(false)
const bulkOperationResponse = ref()
const reorderBulkOperations = ref(false)
const reorderFilters = ref(false)
const displayedCompany = ref(null)
const campaigns = ref([])
const visibleEditForm = ref(false)
const visibleCRMDetails = ref(false)
const visibleContactList = ref(false)
const visibleNewContactForm = ref(false)
const visibleCRMEventForm = ref(false)
const actionButtonId = ref(null)
const summaryActionButtonId = ref(null)
const crmStatusOptions = ref([])
const crmStatuses = ref([])
const crmActionTypes = ref([])
const crmUsers = ref([])
const crmNextActionOption = ref([
    {value: 'None', label: 'None'},
    {value: 'Determine Next Action', label: 'Determine Next Action'},
    {value: 'Scott to Follow-Up', label: 'Scott to Follow-Up'},
    {value: 'BA to Follow-Up', label: 'BA to Follow-Up'},
    {value: 'LG to Follow-Up', label: 'LG to Follow-Up'},
    {value: 'CB to Follow-Up', label: 'CB to Follow-Up'},
    {value: 'Send Initial Email', label:'Send Initial Email' },
    {value: 'Send Another Email', label: 'Send Another Email'},
    {value: 'Send Email on Acquisition', label: 'Send Email on Acquisition'},
    {value: 'Research Correct Email', label: 'Research Correct Email'},
    {value: 'Call', label: 'Call'},
    {value: 'Schedule Meeting', label: 'Schedule Meeting'},
    {value: 'Wait on Response', label: 'Wait on Response'},
    {value: 'Wait for Client Feedback', label: 'Wait for Client Feedback'},
    {value: 'Meet', label: 'Meet'},
    {value: 'Not Now', label: 'Not Now'},
    {value: 'Leave Alone', label: 'Leave Alone'},
    {value: 'Referral Source to Reach Out', label: 'Referral Source to Reach Out'},
    {value: "Send 2nd Email", label: "Send 2nd Email"},
    {value: "Send 3rd Email", label: "Send 3rd Email"},
    {value: "Send 4th Email", label: "Send 4th Email"},
    {value: "Cold Call 1", label: "Cold Call 1"},
    {value: "Cold Call 2", label: "Cold Call 2"},
    {value: "Call again", label: "Call again"},
    {value: "Periodic Check In", label: "Periodic Check In"},
    {value: "Submit IOI", label: "Submit IOI"},
    {value: "Submit LOI", label: "Submit LOI"},
])
const crmNextAction = ref(null)
const crmNextActionDueDate = ref(null)
const previousAction = ref(null)
const resetToPreviousCRMAction = ref(false)
const selectedResultFields = ref(['id', 'company_name', 'website_url'])
const tableHeaders = ref([
    {
        value: 'company_name',
        label: 'Company',
        class: 'p-0 w-[20%] bg-gray-150 border-b-2',
        orderFieldName: "company_name"
    },
    {
        value: 'basic_info',
        label: 'Business',
        class: 'p-0 w-[18%] bg-gray-150 border-b-2',
    },
    {
        value: 'campaign',
        label: 'Campaign',
        class: 'p-0 w-[18%] bg-gray-150 border-b-2',
    },
    {
        value: 'crm_status',
        label: 'CRM',
        class: 'p-0 w-[24%] bg-gray-150 border-b-2',
        orderFieldName: "crm_status"
    },
    {
        value: 'contacts',
        label: 'Contacts',
        class: 'p-0 w-[20%] bg-gray-150 border-b-2',
    },
])

const crmDetailData = reactive({
    action_id: null,
    user_id: store.state.auth.user.id,
    created_by_id: store.state.auth.user.id,
    resolved_date: null,
    action_notes: "",
    company_id: null,
    campaign_id: null
})

const newDetailFormData = reactive({
    action_id: null,
    user_id: store.state.auth.user.id,
    created_by_id: store.state.auth.user.id,
    due_date: null,
    action_notes: "",
    company_id: null,
    campaign_id: null
})

const menuOptions = reactive({
    controlPanel: {
        width: 'w-[330px]',
        panes: ['filters', 'bulkOperations', 'summary'],
        defaultFilterTab: 'pinned'
    },
    loading: {
        rowClass: 'h-60 bg-inherit border-r border-b border-gray-300'
    },
    fetchResultsOnMount: true,
    clearAllActiveFilters: true,
    quickSearch: false,
    selectAll: false,
    selectAllHeader: true,
    expandAllHeader: true,
    paginationArrows: false,
    totalResults: false,
    pageSize: false,
    refreshButton: false,
    createForm: false,
    addFormRows: false,
    exportToCSV: true,
})

const companyFilters = reactive({
    companyName: {
        id: 4,
        name: "company_name",
        label: "Company",
        placeholder: 'ABC Industries',
        value: null,
        defaultValue: null,
        type: 'text',
        widget: 'input',
        multiSelect: false,
        visible: true,
        pinned: false,
    },
    description: {
        id: 5,
        name: "description",
        label: "Description",
        placeholder: 'Keyword in description',
        value: null,
        defaultValue: null,
        type: 'text',
        widget: 'input',
        multiSelect: false,
        visible: true,
        pinned: false,
    },
    websiteURL: {
        id: 6,
        name: "URL",
        label: "Website URL",
        placeholder: 'abc-inc.com',
        value: null,
        defaultValue: null,
        type: 'text',
        widget: 'input',
        multiSelect: false,
        visible: true,
        pinned: false,
    },
    contactPhone: {
        id: 74,
        name: "contact_phone",
        label: "Contact Phone",
        placeholder: '1234567890',
        value: null,
        defaultValue: null,
        type: 'text',
        widget: 'input',
        multiSelect: false,
        visible: true,
        pinned: false,
    },
    address: {
        id: 7,
        name: "address_search",
        label: "Address",
        placeholder: '123 Main St.',
        value: null,
        defaultValue: null,
        type: 'text',
        widget: 'input',
        multiSelect: false,
        visible: true,
        pinned: false,
    },
    source: {
        id: 8,
        name: "source_object",
        label: "Source",
        placeholder: 'XYZ Source',
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"}
        ],
        widget: 'list-box',
        multiSelect: true,
        setOptionsMethod: loadSourceOptions.bind(null),
        visible: true,
        pinned: false,
    },
    sourceExclude: {
        id: 60,
        name: "source_exclude",
        label: "Source Exclude",
        placeholder: 'XYZ Source',
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"}
        ],
        widget: 'list-box',
        multiSelect: true,
        setOptionsMethod: loadSourceOptions.bind(null),
        visible: true,
        pinned: false,
    },
    client: {
        id: 22,
        name: "client_drf",
        label: "Client",
        value: [],
        defaultValue: [],
        placeholder: 'ABC Aerospace',
        options: [
            {value: "clear", label: "------------"}
        ],
        widget: 'list-box',
        multiSelect: true,
        setOptionsMethod: loadClientOptions.bind(null),
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    campaign: {
        id: 1,
        name: "campaign",
        label: "Campaign",
        placeholder: 'ABC Outreach Campaign #1',
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"}
        ],
        widget: 'list-box',
        multiSelect: true,
        setOptionsMethod: loadCampaignOptions.bind(null),
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    campaignExclude: {
        id: 54,
        name: "campaign_exclude",
        label: "Campaign Exclude",
        placeholder: 'ABC Outreach Campaign #1',
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"}
        ],
        widget: 'list-box',
        multiSelect: true,
        setOptionsMethod: loadCampaignOptions.bind(null),
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    tier: {
        id: 10,
        name: "tier_selection",
        label: "Tier",
        placeholder: 'tier_1',
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"}
        ],
        widget: 'list-box',
        multiSelect: true,
        setOptionsMethod: loadTierOptions.bind(null),
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    campaignChangeRequestor: {
        id: 64,
        name: "campaign_change_requestor",
        label: "Campaign Change Requestor",
        placeholder: 'John Smith',
        value: null,
        defaultValue: null,
        options: [
            {value: null, label: "------------"}
        ],
        widget: 'list-box',
        multiSelect: false,
        setOptionsMethod: loadCampaignChangeRequestorOptions.bind(null),
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    clientFeedback: {
        id: 11,
        name: "client_feedback",
        label: "Client Feedback",
        placeholder: 'Approved',
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"},
            {value: "None", label: "None"},
            {value: "approved", label: "Approved"},
            {value: "excluded", label: "Excluded"},
            {value: "hold", label: "Hold"},
            {value: "pass", label: "Pass"},
            {value: "research_further", label: "Research Further"},
        ],
        widget: 'list-box',
        multiSelect: true,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    researchStatus: {
        id: 14,
        name: "research_statuses",
        label: "Research Status",
        placeholder: 'URLs Found, One Zoom Info ID',
        value: [],
        defaultValue: [],
        expression: {
            name: 'research_statuses_lookup',
            value: 'or',
            options: [
                {
                    label: 'Or', 
                    value: 'or'
                },
                {
                    label: 'And',
                    value: 'and',
                }
            ],
        },
        options: [
          {value: "clear", label: "------------"},
          {value: "research_not_complete", label: "Research Not Complete"},
          {value: "research_complete", label: "Research Complete"},
          {value: "research_halted", label: "Research Halted"},
          {value: "url_found", label: "URLs Found"},
          {value: "urls_missing", label: "URLs Missing"},
          {value: "urls_vetted", label: "URLs Vetted"},
          {value: "marked_no_url", label: "Marked No URL"},
          {value: "urls_found_not_vetted", label: "URLs Found Not Vetted"},
          {value: "urls_not_vetted", label: "URLs Not Vetted"},
          {value: "contact_email_missing", label: "Contact Email Missing"},
          {value: "has_primary_contact", label: "Has Primary Contact"},
          {value: "no_primary_contact", label: "No Primary Contact"},
          {value: "primary_outreach_email_missing", label: "Primary Outreach Email Missing"},
          {value: "has_primary_outreach_email", label: "Has Primary Outreach Email"},
          {value: "no_contact", label: "No Contacts"}, 
          {value: "multiple_zoom_info_ids", label: "Multiple Zoom Info IDs"},
          {value: "no_zoom_info_id", label: "No Zoom Info ID"},
          {value: "one_zoom_info_id", label: "One Zoom Info ID"},
          {value: "zi_found_not_enriched", label: "ZI Found Not Enriched"},
          {value: "revenue_found", label: "Revenue Found"},
          {value: "revenue_missing", label: "Revenue Missing"},
          {value: "acquisition_researched", label: 'Acquisiition Researched'},
          {value: "acquisition_not_researched", label: 'Acquisition Not Researched'},
          {value: "do_not_research", label: "Do Not Research"},
          {value: "do_research", label: "Do Research"},
          {value: "further_research_needed", label: "Research Further"},
        ],
        widget: 'list-box',
        multiSelect: true,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    researchStatusTwo: {
        id: 15,
        name: "research_statuses_2",
        label: "Research Status 2",
        placeholder: 'URLs Found, One Zoom Info ID',
        value: [],
        defaultValue: [],
        expression: {
            name: 'research_statuses_2_lookup',
            value: 'or',
            options: [
                {
                    label: 'Or', 
                    value: 'or'
                },
                {
                    label: 'And',
                    value: 'and',
                }
            ],
        },
        options: [
          {value: "clear", label: "------------"},
          {value: "research_not_complete", label: "Research Not Complete"},
          {value: "research_complete", label: "Research Complete"},
          {value: "research_halted", label: "Research Halted"},
          {value: "url_found", label: "URLs Found"},
          {value: "urls_missing", label: "URLs Missing"},
          {value: "urls_vetted", label: "URLs Vetted"},
          {value: "marked_no_url", label: "Marked No URL"},
          {value: "urls_found_not_vetted", label: "URLs Found Not Vetted"},
          {value: "urls_not_vetted", label: "URLs Not Vetted"},
          {value: "contact_email_missing", label: "Contact Email Missing"},
          {value: "has_primary_contact", label: "Has Primary Contact"},
          {value: "no_primary_contact", label: "No Primary Contact"},
          {value: "primary_outreach_email_missing", label: "Primary Outreach Email Missing"},
          {value: "has_primary_outreach_email", label: "Has Primary Outreach Email"},
          {value: "no_contact", label: "No Contacts"}, 
          {value: "multiple_zoom_info_ids", label: "Multiple Zoom Info IDs"},
          {value: "no_zoom_info_id", label: "No Zoom Info ID"},
          {value: "one_zoom_info_id", label: "One Zoom Info ID"},
          {value: "zi_found_not_enriched", label: "ZI Found Not Enriched"},
          {value: "revenue_found", label: "Revenue Found"},
          {value: "revenue_missing", label: "Revenue Missing"},
          {value: "acquisition_researched", label: 'Acquisiition Researched'},
          {value: "acquisition_not_researched", label: 'Acquisition Not Researched'},
          {value: "do_not_research", label: "Do Not Research"},
          {value: "do_research", label: "Do Research"},
          {value: "further_research_needed", label: "Research Further"},
        ],
        widget: 'list-box',
        multiSelect: true,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    revenueRange: {
        id: 69,
        name: 'revenue_range',
        label: 'Min / Max Revenue',
        widget: 'range',
        min: {
            name: 'min_revenue',
            label: 'Min Revenue',
            placeholder: '$1M',
            value: null,
            defaultValue: null,
            type: 'number',
            widget: 'input',
            multiSelect: false,
        },
        max: {
            name: "max_revenue",
            label: 'Max Revenue',
            placeholder: '$100M',
            value: null,
            defaultValue: null,
            type: 'number',
            widget: 'input',
            multiSelect: false,
        },
        visible: true,
        pinned: false,
    },
    ziRevenueRange: {
        id: 70,
        name: 'zi_revenue_range',
        label: 'Min / Max ZI Revenue',
        widget: 'range',
        min: {
            name: 'min_zi_revenue',
            label: 'Min ZI Revenue',
            placeholder: '$1M',
            value: null,
            defaultValue: null,
            type: 'number',
            widget: 'input',
            multiSelect: false,
        },
        max: {
            name: "max_zi_revenue",
            label: 'Max ZI Revenue',
            placeholder: '$100M',
            value: null,
            defaultValue: null,
            type: 'number',
            widget: 'input',
            multiSelect: false,
        },
        visible: true,
        pinned: false,
    },
    ziCombinedRevenueRange: {
        id: 71,
        name: 'revenue_combined_range',
        label: 'Min / Max Combined Revenue',
        widget: 'range',
        min: {
            name: 'min_revenue_combined',
            label: 'Min Combined Revenue',
            placeholder: '$1M',
            value: null,
            defaultValue: null,
            type: 'number',
            widget: 'input',
            multiSelect: false,
        },
        max: {
            name: "max_revenue_combined",
            label: 'Max Combined Revenue',
            placeholder: '$100M',
            value: null,
            defaultValue: null,
            type: 'number',
            widget: 'input',
            multiSelect: false,
        },
        visible: true,
        pinned: false,
    },
    headcountRange: {
        id: 73,
        name: 'headcount_range',
        label: 'Min / Max Headcount',
        widget: 'range',
        min: {
            name: 'min_headcount',
            label: 'Min Headcount',
            placeholder: '5 FTE',
            value: null,
            defaultValue: null,
            type: 'number',
            widget: 'input',
            multiSelect: false,
        },
        max: {
            name: "max_headcount",
            label: 'Max Headcount',
            placeholder: '500 FTE',
            value: null,
            defaultValue: null,
            type: 'number',
            widget: 'input',
            multiSelect: false,
        },
        visible: true,
        pinned: false,
    },
    dueDateRange: {
        id: 72,
        name: 'due_date_range',
        label: 'Due Date Start / End',
        widget: 'range',
        min: {
            name: "due_date_start",
            label: "Due Date Start",
            placeholder: 'mm/dd/yyyy',
            value: null,
            defaultValue: null,
            type: 'date',
            widget: 'input',
            multiSelect: false,
            awaitingOptions: false,
        },
        max: {
            name: "due_date_end",
            label: "Due Date End",
            placeholder: 'mm/dd/yyyy',
            value: null,
            defaultValue: null,
            type: 'date',
            widget: 'input',
            multiSelect: false,
            awaitingOptions: false,
        },
        visible: true,
        pinned: false,
    },
    crmStatus: {
        id: 26,
        name: "crm_status",
        label: "CRM Status",
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"}
        ],
        widget: 'list-box',
        multiSelect: true,
        setOptionsMethod: loadCRMStatusOptions.bind(null),
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    crmStatusExclude: {
        id: 75,
        name: "crm_status_exclude",
        label: "CRM Status Exclude",
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"}
        ],
        widget: 'list-box',
        multiSelect: true,
        setOptionsMethod: loadCRMStatusOptions.bind(null),
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    crmNextAction: {
        id: 27,
        name: "next_action",
        label: "CRM Next Action",
        value: [],
        defaultValue: [],
        options: [
         {value: "clear", label: "------------"},
          {value: 'None', label: 'None'},
          {value: 'Determine Next Action', label: 'Determine Next Action'},
          {value: 'Scott to Follow-Up', label: 'Scott to Follow-Up'},
          {value: 'BA to Follow-Up', label: 'BA to Follow-Up'},
          {value: 'LG to Follow-Up', label: 'LG to Follow-Up'},
          {value: 'CB to Follow-Up', label: 'CB to Follow-Up'},
          {value: 'Send Initial Email', label:'Send Initial Email' },
          {value: 'Send Another Email', label: 'Send Another Email'},
          {value: 'Send Email on Acquisition', label: 'Send Email on Acquisition'},
          {value: 'Research Correct Email', label: 'Research Correct Email'},
          {value: 'Call', label: 'Call'},
          {value: 'Schedule Meeting', label: 'Schedule Meeting'},
          {value: 'Wait on Response', label: 'Wait on Response'},
          {value: 'Wait for Client Feedback', label: 'Wait for Client Feedback'},
          {value: 'Meet', label: 'Meet'},
          {value: 'Not Now', label: 'Not Now'},
          {value: 'Leave Alone', label: 'Leave Alone'},
          {value: 'Referral Source to Reach Out', label: 'Referral Source to Reach Out'},
          {value: "Send 2nd Email", label: "Send 2nd Email"},
          {value: "Send 3rd Email", label: "Send 3rd Email"},
          {value: "Send 4th Email", label: "Send 4th Email"},
          {value: "Cold Call 1", label: "Cold Call 1"},
          {value: "Cold Call 2", label: "Cold Call 2"},
          {value: "Call again", label: "Call again"},
          {value: "Periodic Check In", label: "Periodic Check In"},
          {value: "Submit IOI", label: "Submit IOI"},
          {value: "Submit LOI", label: "Submit LOI"},
        ],
        widget: 'list-box',
        multiSelect: true,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    collectionTag: {
        id: 3,
        name: "collection_tag",
        label: "Collection Tag",
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"}
        ],
        widget: 'combo-box',
        multiSelect: true,
        setOptionsMethod: loadCollectionTagOptions.bind(null),
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    collectionReview: {
        id: 58,
        name: 'collection_interest',
        label: 'Collection Review',
        placeholder: 'My Collection',
        value: null,
        defaultValue: null,
        options: [
            {value: null, label: "------------"},
            {value: "None", label: "None"},
            {value: "Interesting", label: "Interesting"},
            {value: "Not Interesting", label: "Not Interesting"},
        ],
        widget: 'list-box',
        multiSelect: false,
        awaitingOptions: false,
        visible: false,
        pinned: false
    },
    collectionTagExclude: {
        id: 52,
        name: "collection_tag_exclude",
        label: "Collection Tag Exclude",
        placeholder: 'Another Collection',
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"}
        ],
        widget: 'combo-box',
        multiSelect: true,
        setOptionsMethod: loadCollectionTagOptions.bind(null),
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    collectionTagSources: {
        id: 45,
        name: "collection_tag_async_job",
        label: "Collection Tag Sources",
        placeholder: 'My Full-Text Search',
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"}
        ],
        widget: 'list-box',
        multiSelect: true,
        setOptionsMethod: loadCollectionTagSourcesOptions.bind(null),
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    state: {
        id: 29,
        name: "state",
        label: "State",
        placeholder: 'Texas',
        value: [],
        defaultValue: [],
        expression: {
            name: 'state_lookup',
            value: 'or',
        },
        options: [
          {value: "clear", label: "------------"},
          {value: 'alabama', label: 'Alabama'},
          {value: 'alaska', label: 'Alaska'},
          {value: 'arizona', label: 'Arizona'},
          {value: 'arkansas', label: 'Arkansas'},
          {value: 'california', label: 'California'},
          {value: 'colorado', label: 'Colorado'},
          {value: 'connecticut', label: 'Connecticut'},
          {value: 'delaware', label: 'Delaware'},
          {value: 'florida', label: 'Florida'},
          {value: 'georgia', label: 'Georgia'},
          {value: 'hawaii', label: 'Hawaii'},
          {value: 'idaho', label: 'Idaho'},
          {value: 'illinois', label: 'Illinois'},
          {value: 'indiana', label: 'Indiana'},
          {value: 'iowa', label: 'Iowa'},
          {value: 'kansas', label: 'Kansas'},
          {value: 'kentucky', label: 'Kentucky'},
          {value: 'louisiana', label: 'Louisiana'},
          {value: 'maine', label: 'Maine'},
          {value: 'maryland', label: 'Maryland'},
          {value: 'massachusetts', label: 'Massachusetts'},
          {value: 'michigan', label: 'Michigan'},
          {value: 'minnesota', label: 'Minnesota'},
          {value: 'mississippi', label: 'Mississippi'},
          {value: 'missouri', label: 'Missouri'},
          {value: 'montana', label: 'Montana'},
          {value: 'nebraska', label: 'Nebraska'},
          {value: 'nevada', label: 'Nevada'},
          {value: 'new_hampshire', label: 'New Hampshire'},
          {value: 'new_jersey', label: 'New Jersey'},
          {value: 'new_mexico', label: 'New Mexico'},
          {value: 'new_york', label: 'New York'},
          {value: 'north_carolina', label: 'North Carolina'},
          {value: 'north_dakota', label: 'North Dakota'},
          {value: 'ohio', label: 'Ohio'},
          {value: 'oklahoma', label: 'Oklahoma'},
          {value: 'oregon', label: 'Oregon'},
          {value: 'pennsylvania', label: 'Pennsylvania'},
          {value: 'rhode_island', label: 'Rhode Island'},
          {value: 'south_carolina', label: 'South Carolina'},
          {value: 'south_dakota', label: 'South Dakota'},
          {value: 'tennessee', label: 'Tennessee'},
          {value: 'texas', label: 'Texas'},
          {value: 'utah', label: 'Utah'},
          {value: 'vermont', label: 'Vermont'},
          {value: 'virginia', label: 'Virginia'},
          {value: 'washington', label: 'Washington'},
          {value: 'west_virginia', label: 'West Virginia'},
          {value: 'wisconsin', label: 'Wisconsin'},
          {value: 'wyoming', label: 'Wyoming'}
        ],
        widget: 'list-box',
        multiSelect: true,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    regions: {
        id: 82,
        name: "regions",
        label: "Regions",
        placeholder: 'Europe',
        value: [],
        defaultValue: [],
        options: [
          {value: "clear", label: "------------"},
          {value: 'Africa', label: 'Africa'},
          {value: 'Asia', label: 'Asia'},
          {value: 'Europe', label: 'Europe'},
          {value: 'North America', label: 'North America'},
          {value: 'South America', label: 'South America'},
          {value: 'Oceania', label: 'Oceania'}
        ],
        widget: 'list-box',
        multiSelect: true,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    drivingTimeFocus: {
        id: 30,
        name: "driving_distance_focus",
        label: "Driving Time Focus",
        placeholder: 'My point of interest',
        value: null,
        defaultValue: null,
        widget: 'list-box',
        options: [
          {value: "clear", label: "------------"}
        ],
        setOptionsMethod: loadDrivingTimeFocusOptions.bind(null),
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    drivingTime: {
        id: 31,
        name: "driving_time",
        label: "Driving Time",
        placeholder: '90 minutes',
        value: null,
        defaultValue: null,
        expression: {
            name: 'driving_time_lookup',
            value: 'mins',
            options: [
                {
                    label: 'Mins', 
                    value: 'mins'
                },
                {
                    label: 'Hours',
                    value: 'hours',
                }
            ],
        },
        type: 'number',
        widget: 'input',
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    naics: {
        id: 32,
        name: "naics_code",
        label: "NAICS Code",
        value: [],
        defaultValue: [],
        widget: 'list-box',
        options: [
          {value: "clear", label: "------------"}
        ],
        setOptionsMethod: loadNAICSOptions.bind(null),
        multiSelect: true,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    taskUser: {
        id: 2,
        name: "task_user",
        label: "CRM Details User",
        value: [],
        defaultValue: [],
        widget: 'list-box',
        options: [
          {value: "clear", label: "------------"}
        ],
        setOptionsMethod: loadTaskUserOptions.bind(null),
        multiSelect: true,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    // researchHalted: {
    //     id: 34,
    //     name: "show_research_halted",
    //     label: "Research Halted",
    //     value: 'False',
    //     defaultValue: 'False',
    //     widget: 'list-box',
    //     options: [
    //         {value: "True", label: "Show"},
    //         {value: "False", label: "Don't Show"}
    //     ],
    //     multiSelect: false,
    //     awaitingOptions: false,
    //     visible: true,
    //     pinned: false,
    // },
    problemStatus: {
        id: 37,
        name: "problem_status",
        label: "Problem Status",
        value: null,
        defaultValue: null,
        widget: 'list-box',
        options: [
            {value: null, label: "------------"},
            {value: 'has_problem_company_notes', label: 'Has Problem Company Notes'},
            {value: 'no_problem_company_notes', label: 'No Problem Company Notes'},
        ],
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    }, 
    accountManagerResearchNotes: {
        id: 38,
        name: "account_manager_research_notes",
        label: "Account Manager Notes",
        placeholder: 'Keyword in notes',
        value: null,
        defaultValue: null,
        type: 'text',
        widget: 'input',
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    companyId: {
        id: 39,
        name: "id_number",
        label: "Company ID",
        placeholder: '123456',
        value: null,
        defaultValue: null,
        type: 'text',
        widget: 'input',
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    relevantBusiness: {
        id: 42,
        name: "relevant_business",
        label: "Relevant Business",
        placeholder: 'My relevant business',
        value: null,
        defaultValue: null,
        type: 'text',
        widget: 'input',
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    referralSource: {
        id: 43,
        name: "referrer",
        label: "Referral Source",
        placeholder: 'My Referrer',
        value: [],
        defaultValue: [],
        widget: 'list-box',
        options: [
          {value: "clear", label: "------------"}
        ],
        setOptionsMethod: loadReferralSourceOptions.bind(null),
        multiSelect: true,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    referralStatus: {
        id: 44,
        name: "referrer_status",
        label: "Referral Status",
        placeholder: 'No Referrer',
        value: null,
        defaultValue: null,
        widget: 'list-box',
        options: [
          {value: null, label: "------------"},
          {value: 'has_referrer', label: 'Has Referrer'},
          {value: 'no_referrer', label: 'No Referrer'}
        ],
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    productServiceCode: {
        id: 46,
        name: "product_service_code",
        label: "Product Service Code",
        placeholder: 'PSC Code 1234',
        value: null,
        defaultValue: null,
        type: 'text',
        widget: 'input',
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    crmEvents: {
        id: 51,
        name: 'crm_action',
        label: 'CRM Events',
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"},
        ],
        widget: 'list-box',
        multiSelect: true,
        awaitingOptions: false,
        visible: true,
        pinned: false
    },
    hasCRMEvents: {
        id: 53,
        name: 'has_crm_actions',
        label: 'Has CRM Events',
        value: null,
        defaultValue: null,
        options: [
            {value: null, label: "------------"}, 
            {value: "True", label: "True"} 
        ],
        widget: 'list-box',
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false
    },
    parentType: {
        id: 57,
        name: 'parent_type',
        label: 'Parent Type',
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"},
            {value: "None", label: "No Parent Type"},
            {value: "Government Owned", label: "Government Owned"},
            {value: "Private Equity Owned", label: "Private Equity Owned"},
            {value: "Proprietor Owned", label: "Proprietor Owned"},
            {value: "Public", label: "Public"}, 
        ],
        widget: 'list-box',
        multiSelect: true,
        awaitingOptions: false,
        visible: true,
        pinned: false
    },
    hasConflicts: {
        id: 56,
        name: 'has_conflict',
        label: 'Has Conflicts',
        value: null,
        defaultValue: null,
        options: [
            {value: null, label: "------------"},
            {value: "True", label: "True"},
            {value: "False", label: "False"}
        ],
        widget: 'list-box',
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false
    },
    cageCode: {
        id: 62,
        name: "cage_code",
        label: "Cage Code",
        placeholder: '12345',
        value: null,
        defaultValue: null,
        type: 'text',
        widget: 'input',
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    previousCampaign: {
        id: 67,
        name: "previous_campaign",
        label: "Previous Campaign",
        placeholder: 'ABC Old Campaign #1',
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"}
        ],
        widget: 'list-box',
        multiSelect: true,
        setOptionsMethod: loadCampaignOptions.bind(null),
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    samUEI: {
        id: 63,
        name: "unique_entity_identifier_sam",
        label: "UEI Sam",
        placeholder: 'A123BCDEFG45',
        value: null,
        defaultValue: null,
        type: 'text',
        widget: 'input',
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    country: {
        id: 68,
        name: 'country',
        label: 'Country',
        placeholder: 'USA',
        value: [],
        defaultValue: [],
        options: [
            {value: "clear", label: "------------"},
            {value: "USA", label: "USA"}
        ],
        widget: 'list-box',
        multiSelect: true,
        awaitingOptions: false,
        visible: true,
        pinned: false
    },
    enrichedAfter: {
        id: 61,
        name: "enriched_after",
        label: "ZI Created After",
        value: null,
        defaultValue: null,
        type: 'date',
        widget: 'input',
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    category: {
        id: 41,
        name: "category_search",
        label: "Category",
        placeholder: 'Manufacturing',
        value: null,
        defaultValue: null,
        type: 'text',
        widget: 'input',
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false,
    },
    parentCompanyStatus: {
        id: 35,
        name: 'parent_company_status',
        label: 'Parent Company Status',
        value: null,
        defaultValue: null,
        options: [
            {value: null, label: "------------"},
            {value: 'has_parent_company', label: 'Has Parent Company'},
            {value: 'no_parent_company', label: 'No Parent Company'},
        ],
        widget: 'list-box',
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false
    },
    investorsStatus: {
        id: 36,
        name: 'investors_status',
        label: 'Investors Status',
        value: null,
        defaultValue: null,
        options: [
            {value: null, label: "------------"},
            {value: 'has_investors', label: 'Has Investors'},
            {value: 'no_investors', label: 'No Investors'},
        ],
        widget: 'list-box',
        multiSelect: false,
        awaitingOptions: false,
        visible: true,
        pinned: false
    },
    crmStatusDate: {
        id: 76,
        name: 'crm_status_date',
        label: 'CRM Status Date',
        widget: 'range',
        min: {
            name: "crm_status_date_after",
            label: "CRM Status Date After",
            placeholder: 'mm/dd/yyyy',
            value: null,
            defaultValue: null,
            type: 'date',
            widget: 'input',
            multiSelect: false,
            awaitingOptions: false,
        },
        max: {
            name: "crm_status_date_before",
            label: "CRM Status Date Before",
            placeholder: 'mm/dd/yyyy',
            value: null,
            defaultValue: null,
            type: 'date',
            widget: 'input',
            multiSelect: false,
            awaitingOptions: false,
        },
        visible: true,
        pinned: false,
    },
})

const isDevOrAccountManager = computed(() => {
    const hasPermission = store.state.auth.userPermissions.isAccountManager || store.state.auth.userPermissions.isDev
    return hasPermission
})

const companyBulkOperations = reactive({
    assignAllToCollection: {
        id: 1,
        label: 'Assign All Results To Collection',
        modelPath: 'companies',
        endpoint: 'bulk_assign_query_results_to_collection_tag',
        message: '',
        requireSelectedResults: false,
        payloadType: 'form',
        inputs: {
            collectionTag: {
                key: 'collection_tag_name',
                label: "Choose Collection Tag",
                value: [],
                defaultValue: [],
                required: true,
                visible: true,
                options: [
                    {value: "clear", label: "------------"}
                ],
                widget: 'datalist',
                multiSelect: true,
                showSelectedInputValues: true,
            }
        },
        pinned: false
    },
    assignToCollection: {
        id: 2,
        label: 'Assign To Collection',
        modelPath: 'companies',
        endpoint: 'bulk_assign_collection_tag',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            collectionTag: {
                label: "Choose Collection Tag",
                value: [],
                defaultValue: [],
                required: false,
                visible: true,
                options: [
                    {value: "clear", label: "------------"}
                ],
                widget: 'datalist',
                multiSelect: true,
                showSelectedInputValues: true,
            }
        },
        pinned: false,
    },
    removeFromCollection: {
        id: 3,
        label: 'Remove From Collection',
        modelPath: 'companies',
        endpoint: 'bulk_remove_collection_tag',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            collectionTag: {
                label: "Choose Collection Tag",
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                options: [
                    {value: "clear", label: "------------"}
                ],
                widget: 'list-box',
                multiSelect: false,
            }
        },
        pinned: false,
    },
    getZoomInfoIDs: {
        id: 4,
        label: 'Get ZI IDs',
        modelPath: 'companies',
        endpoint: 'bulk_get_zoom_info_ids',
        message: '',
        requireSelectedResults: true,
        limit: 10,
        payloadType: null,
        inputs: {},
        pinned: false,
    },
    getZoomInfoBasic: {
        id: 5,
        label: 'Get ZI Basic',
        modelPath: 'companies',
        endpoint: 'bulk_enrich_zoom_info_companies',
        message: '',
        requireSelectedResults: true,
        payloadType: null,
        limit: 10,
        inputs: {},
        pinned: false,
    },
    transferZoomInfoBasic: {
        id: 6,
        label: 'Transfer ZI Basic',
        modelPath: 'companies',
        endpoint: 'bulk_transfer_zi_basic',
        message: '',
        requireSelectedResults: true,
        payloadType: null,
        inputs: {},
        pinned: false,
    },
    updateCategory: {
        id: 7,
        label: 'Update Category',
        modelPath: 'companies',
        endpoint: 'bulk_update_category',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            category: {
                label: "Update Category",
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                widget: 'input',
                type: 'text',
            }
        },
        pinned: false,
    },
    updateRelevantBusiness: {
        id: 8,
        label: 'Update Relevant Business',
        modelPath: 'companies',
        endpoint: 'bulk_update_relevant_business',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
           relevantBusiness: {
                label: "Relevant Business",
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                widget: 'input',
                type: 'text',
            }
        },
        pinned: false,
    },
    addArchiveReason: {
        id: 9,
        label: 'Add Archive Reason',
        modelPath: 'companies',
        endpoint: 'bulk_mark_archive_reason',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            archiveReason: {
                label: "Archive Reason",
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                options: [
                    {value: "null", label: "------------"},
                    {value: "Does Not Exist", label: "Does Not Exist"},
                    {value: "Not Aerospace", label: "Not Aerospace"},
                    {value: "Permanently Closed", label: "Permanently Closed"},
                ],
                widget: 'list-box',
                multiSelect: false,
            },
        },
        pinned: false,
    },
    markTier: {
        id: 26,
        label: 'Mark Tier #',
        modelPath: 'companies',
        endpoint: 'bulk_mark_tier',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            tier: {
                label: "Choose Tier",
                value: 5,
                defaultValue: 5,
                required: true,
                visible: true,
                options: [
                    {value: 1, label: 'Tier 1'},
                    {value: 2, label: 'Tier 2'},
                    {value: 3, label: 'Tier 3'},
                    {value: 4, label: 'Tier 4'},
                    {value: 5, label:'Tier 5 (Review)'},
                    {value: null, label: 'Remove Tier'},
                ],
                widget: 'list-box',
                multiSelect: false,
            }
        },
        pinned: false,
    },
    markTierOne: {
        id: 10,
        label: 'Mark Tier 1',
        modelPath: 'companies',
        endpoint: 'bulk_mark_tier',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            tier: {
                visible: false,
                value: 1,
                defaultValue: 1,
            }
        },
        pinned: false,
    },
    markTierTwo: {
        id: 11,
        label: 'Mark Tier 2',
        modelPath: 'companies',
        endpoint: 'bulk_mark_tier',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            tier: {
                visible: false,
                value: 2,
                defaultValue: 2,
            }
        },
        pinned: false,
    },
    markTierThree: {
        id: 12,
        label: 'Mark Tier 3',
        modelPath: 'companies',
        endpoint: 'bulk_mark_tier',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            tier: {
                visible: false,
                value: 3,
                defaultValue: 3,
            }
        },
        pinned: false,
    },
    markTierFour: {
        id: 13,
        label: 'Mark Tier 4',
        modelPath: 'companies',
        endpoint: 'bulk_mark_tier',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            tier: {
                visible: false,
                value: 4,
                defaultValue: 4,
            }
        },
        pinned: false,
    },
    markTierFive: {
        id: 14,
        label: 'Mark Tier 5',
        modelPath: 'companies',
        endpoint: 'bulk_mark_tier',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            tier: {
                visible: false,
                value: 5,
                defaultValue: 5,
            }
        },
        pinned: false,
    },
    assignToCampaign: {
        id: 15,
        label: 'Move To Campaign',
        modelPath: 'companies',
        endpoint: 'bulk_assign_to_campaign',
        message: '',
        requireSelectedResults: true,
        payloadType: 'form',
        inputs: {
            campaign: {
                label: "Choose Target Campaign",
                key: 'campaign_id',
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                options: [
                    {value: "clear", label: "------------"}
                ],
                widget: 'list-box',
                multiSelect: false,
            },
            copyCRMDetails: {
                label: "Copy CRM Details?",
                key: 'copy_details',
                value: null,
                defaultValue: null,
                required: false,
                visible: true,
                widget: 'checkbox',
            },
            removeCampaignAfterAssigning: {
                label: "Remove Companies from Target Campaign When Done?",
                key: 'remove_campaign_after_assigning',
                value: null,
                defaultValue: null,
                required: false,
                visible: isDevOrAccountManager.value,
                widget: 'checkbox',
            }, archiveEmptySourceCampaigns: {
                label: "Archive Source Campaigns if Empty?",
                key: 'archive_empty_source_campaigns',
                value: null,
                defaultValue: null,
                required: false,
                visible: isDevOrAccountManager.value,
                widget: 'checkbox'
            }, archiveEmptyNewCampaigns: {
                label: "Archive Target Campaign If Empty?",
                key: 'archive_empty_new_campaign',
                value: null,
                defaultValue: null,
                required: false,
                visible: isDevOrAccountManager.value,
                widget: 'checkbox'
            }
        },
        pinned: false,
    },
    removeFromCampaign: {
        id: 16,
        label: 'Remove From Campaign',
        modelPath: 'companies',
        endpoint: 'bulk_remove_from_campaign',
        message: '',
        requireSelectedResults: true,
        payloadType: null,
        inputs: {},
        pinned: false,
    },
    resolveDuplicates: {
        id: 17,
        label: 'Resolve Duplicates',
        modelPath: 'companies',
        endpoint: 'bulk_resolve_duplicates',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            winningURL: {
                label: "Please enter the correct url for all selected companies",
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                widget: 'input',
                type: 'text',
            }
        },
        pinned: false,
    },
    updateCRMNextAction: {
        id: 18,
        label: 'Update CRM Next Action',
        modelPath: 'companies',
        endpoint: 'bulk_mark_crm_next_action',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            crmNextAction: {
                label: "Choose Next Action",
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                options: [
                    {value: 'None', label: 'None'},
                    {value: 'Determine Next Action', label: 'Determine Next Action'},
                    {value: 'Scott to Follow-Up', label: 'Scott to Follow-Up'},
                    {value: 'BA to Follow-Up', label: 'BA to Follow-Up'},
                    {value: 'LG to Follow-Up', label: 'LG to Follow-Up'},
                    {value: 'CB to Follow-Up', label: 'CB to Follow-Up'},
                    {value: 'Send Initial Email', label:'Send Initial Email' },
                    {value: 'Send Another Email', label: 'Send Another Email'},
                    {value: 'Send Email on Acquisition', label: 'Send Email on Acquisition'},
                    {value: 'Research Correct Email', label: 'Research Correct Email'},
                    {value: 'Call', label: 'Call'},
                    {value: 'Schedule Meeting', label: 'Schedule Meeting'},
                    {value: 'Wait on Response', label: 'Wait on Response'},
                    {value: 'Wait for Client Feedback', label: 'Wait for Client Feedback'},
                    {value: 'Meet', label: 'Meet'},
                    {value: 'Not Now', label: 'Not Now'},
                    {value: 'Leave Alone', label: 'Leave Alone'},
                    {value: 'Referral Source to Reach Out', label: 'Referral Source to Reach Out'},
                    {value: "Send 2nd Email", label: "Send 2nd Email"},
                    {value: "Send 3rd Email", label: "Send 3rd Email"},
                    {value: "Send 4th Email", label: "Send 4th Email"},
                    {value: "Cold Call 1", label: "Cold Call 1"},
                    {value: "Cold Call 2", label: "Cold Call 2"},
                    {value: "Call again", label: "Call again"},
                    {value: "Periodic Check In", label: "Periodic Check In"},
                    {value: "Submit IOI", label: "Submit IOI"},
                    {value: "Submit LOI", label: "Submit LOI"},
                ],
                widget: 'list-box',
                multiSelect: false,
            }
        },
        pinned: false,
    },
    updateCRMNextActionDueDate: {
        id: 19,
        label: 'Update CRM Due Date',
        modelPath: 'companies',
        endpoint: 'bulk_mark_crm_next_action_due_date',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            crmNextActionDueDate: {
                label: "Choose CRM Next Action Due Date",
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                widget: 'input',
                type: 'date',
            }
        },
        pinned: false,
    },
    addNewCRMDetail: {
        id: 20,
        label: 'Add New CRM Detail',
        modelPath: 'companies',
        endpoint: 'bulk_add_new_crm_action',
        message: '',
        requireSelectedResults: true,
        payloadType: 'form',
        inputs: {
            crmDetail: {
                label: "Detail",
                key: 'action_id',
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                options: [
                    {value: null, label: "------------"}
                ],
                widget: 'list-box',
                multiSelect: false,
            },
            dueDate: {
                label: "Due Date",
                key: 'due_date',
                value: null,
                defaultValue: null,
                required: false,
                visible: true,
                widget: 'input',
                type: 'date',
            },
            resolvedDate: {
                label: "Resolved Date",
                key: 'resolved_date',
                value: null,
                defaultValue: null,
                required: false,
                visible: true,
                widget: 'input',
                type: 'date',
            },

            user: {
                label: "User",
                key: 'user',
                value: null,
                defaultValue: null,
                required: false,
                visible: true,
                options: [
                    {value: "clear", label: "------------"}
                ],
                widget: 'list-box',
                multiSelect: false,
            },
            emailTemplate: {
                label: "Paste Email Template Body to CRM Detail Note",
                value: null,
                defaultValue: null,
                required: false,
                visible: true,
                options: [
                    {value: "clear", label: "------------"}
                ],
                htmlLabel: true,
                widget: 'list-box',
                multiSelect: false,
                excludeFromPayload: true,
                async onUpdate(bulkAction, templateValue) {
                    await updateCRMDetailNotesFromEmailTemplate(bulkAction, templateValue)
                    // console.log('onUpdate', bulkAction, templateValue)
                    // let emailTemplate = bulkAction.inputs.emailTemplate.options.find((emailOption) => emailOption.value == templateValue)
                    // bulkAction.inputs.note.value = emailTemplate.label
                    // bulkAction.inputs.emailTemplate.value = null
                    // if(emailTemplate) {
                    //     emailBody = emailTemplate.data.body
                    //     bulkAction.inputs.
                    // }

                }
            },
            note: {
                label: "Note",
                key: 'action_notes',
                value: null,
                defaultValue: null,
                required: false,
                visible: true,
                widget: 'textarea',
                rows: 6,
                type: 'text',
            },
            status: {
                visible: false,
                key: 'status',
                value: 'Open',
            }
        },
        pinned: false,
    },
    updateCRMStatus: {
        id: 21,
        label: 'Update CRM Status',
        modelPath: 'companies',
        endpoint: 'bulk_assign_new_crm_status',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            crmStatus: {
                label: "Choose CRM Status",
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                options: [
                    {value: "clear", label: "------------"}
                ],
                widget: 'list-box',
                multiSelect: false,
            }
        },
        pinned: false,
    },
    updateClientFeedback: {
        id: 22,
        label: 'Update Client Feedback',
        modelPath: 'companies',
        endpoint: 'bulk_mark_client_feedback',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            clientFeedback: {
                label: "Choose Client Feedback",
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                options: [
                    {value: 'noFeedback', label: 'None'},
                    {value: 'approved', label: 'Approved'},
                    {value: 'excluded', label: 'Excluded'},
                    {value: 'hold', label: 'Hold'},
                    {value: 'pass', label: 'Pass'},
                    {value: 'research_further', label: 'Research Further'},
                ],
                widget: 'list-box',
                multiSelect: false,
            }
        },
        pinned: false,
    },
    sendEmail: {
        id: 23,
        label: 'Bulk Send Email',
        modelPath: 'companies',
        endpoint: 'bulk_send_email_template',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            emailTemplate: {
                label: "Choose Email Template",
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                options: [
                    {value: "clear", label: "------------"}
                ],
                widget: 'list-box',
                multiSelect: false,
            }
        },
        pinned: false,
    },
    prepareDrafts: {
        id: 28,
        label: 'Prepare Outreach Drafts',
        modelPath: 'companies',
        endpoint: 'prepare_outreach_drafts',  // not hit directly -- override below
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            emailTemplate: {
                label: "Choose Email Template",
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                options: [
                    {value: "clear", label: "------------"}
                ],
                widget: 'list-box',
                multiSelect: false,
            }
        },
        pinned: false,
        // New pipeline: render in-system OutreachDrafts for the selected companies
        // (nothing is sent here). The analyst reviews/cleans with AI assist and
        // sends from the Outreach Drafts page (Graph send-as, attachments, CRM detail).
        overrideAction: true,
        async performBulkAction(actionData) {
            const token = store.state.auth.token
            const templateId = actionData.payload
            const companyIds = (actionData.selectedResults || []).map(({ id }) => id)
            if (!templateId || templateId === 'clear') {
                $toast.open({ message: 'Choose an email template first.', type: 'error', duration: 5000 })
                return
            }
            if (!companyIds.length) {
                $toast.open({ message: 'No companies selected.', type: 'error', duration: 5000 })
                return
            }
            try {
                const result = await prepareOutreachDrafts({ templateId, companyIds }, token)
                const parts = [`${result?.created ?? 0} created`]
                if (result?.refreshed) parts.push(`${result.refreshed} refreshed`)
                if (result?.blocked) parts.push(`${result.blocked} blocked (no recipient)`)
                $toast.open({
                    message: `Prepared outreach drafts: ${parts.join(', ')}. Review them on the Outreach Drafts page.`,
                    type: 'success',
                    duration: 6000,
                })
                if (!actionData.keepSelected) clearSelectedResults()
            } catch (e) {
                $toast.open({ message: 'Could not prepare outreach drafts.', type: 'error', duration: 8000 })
            }
        },
    },
    assignCrmSpreadsheetUsers: {
        id: 27,
        label: 'Assign CRM Spreadsheet Users',
        modelPath: 'companies',
        endpoint: 'bulk_assign_crm_spreadsheet_users',
        message: '',
        requireSelectedResults: true,
        payloadType: 'simple',
        inputs: {
            crmUsers: {
                label: "Choose Users to Assign",
                value: [],
                defaultValue: [],
                required: true,
                visible: true,
                options: [
                ],
                widget: 'combo-box',
                multiSelect: true,
            }
        },
        pinned: false,
    },
    exportZoomInfoIDs: {
        id: 24,
        label: 'Export ZI IDs',
        modelPath: 'companies',
        endpoint: 'export_zi_ids',
        message: '',
        requireSelectedResults: true,
        payloadType: null,
        inputs: {},
        pinned: false,
        overrideAction: true,
        performBulkAction (actionData) {
            createZIUploadCsv(actionData.selectedResults)
            handleBulkActionResponse(actionData, {status: 200})
        }
    },
    createResearchAssignment: {
        id: 25,
        label: 'Create Research Assignment',
        modelPath: 'companies',
        endpoint: 'create_research_assignment',
        message: '',
        requireSelectedResults: true,
        payloadType: 'form',
        inputs: {
            researchPage: {
                label: "Research Page",
                key: 'research_page',
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                options: [
                    {value: "clear", label: "------------"},
                    {value: "missing_url_or_zoom_info_companies", label: "Missing URL or ZoomInfo"},
                    {value: "vet_urls", label: "Vet URLs"}
                ],
                widget: 'list-box',
                multiSelect: false,
            },
            assignmentName: {
                label: "Assignment Name",
                key: 'assignment_name',
                value: null,
                defaultValue: null,
                required: false,
                visible: true,
                widget: 'input',
                type: 'text',
            },
            user: {
                label: "User",
                key: 'user_id',
                value: null,
                defaultValue: null,
                required: true,
                visible: true,
                options: [
                    {value: null, label: "------------"}
                ],
                widget: 'list-box',
                multiSelect: false,
            }
        },
        pinned: false,
    },
})

const defaultCampaignId = ref(null)

const companyRowActions = reactive({
    // A row changed something itself (e.g. a client feedback note) and needs fresh data
    reloadCompanies: {
        performAction() {
            reloadCompanies()
        }
    },
    openEditForm: {
        performAction(actionData) {
            displayedCompany.value = actionData.company
            visibleEditForm.value = true
        }
    },
    openCRMDetails: {
        performAction(actionData) {
            displayedCompany.value = actionData.company
            defaultCampaignId.value = actionData.defaultCampaign
            visibleCRMDetails.value = true
        }
    },
    addContact: {
        performAction(actionData) {
            // console.log('companyActionRows: addContact')
            displayedCompany.value = actionData.company
            visibleNewContactForm.value = true
        }
    },
    clearZoomInfo: {
        async performAction(actionData) {
            // console.log('companyRowActions: clearZoomInfo')
            const token = store.state.auth.token
            const response = await clearZoomInfo(actionData.company.id, token)
            handleActionResponse(response, actionData.buttonId, `${actionData.company.company_name} - ${actionData.company.id}: Error Clearing Zoom Info.`)
        }
    },
    getZoomInfoID: {
        async performAction(actionData) {
            // console.log('companyRowActons: getZoomInfoID')
            const token = store.state.auth.token
            const response = await getZoomInfoId(actionData.company.id, token)
            handleActionResponse(response, actionData.buttonId, `${actionData.company.company_name} - ${actionData.company.id}: Error Getting ZI ID.`)
        }
    },
    getZoomInfoBasic: {
        async performAction(actionData) {
            // console.log('companyRowActons: getZoomInfoBasic')
            const token = store.state.auth.token
            const response = await getZoomInfoBasic(actionData.company.id, token)
            handleActionResponse(response, actionData.buttonId, `${actionData.company.company_name} - ${actionData.company.id}: Error updating ZI Basic.`)
        }
    },
    markTier: {
        async performAction(actionData)  {
            // console.log('companyRowActons: markTier', actionData.payload)
            const token = store.state.auth.token
            const response = await markTier(actionData.company.id, actionData.payload, token)
            handleActionResponse(response, actionData.buttonId, `${actionData.company.company_name} - ${actionData.company.id}: Error marking tier.`)
        }
    },
    // markURLVetted, markURLUnvetted
    updateCRMStatus: {
        async performAction(actionData) {
            // console.log('companyActionRows: updateCRMStatus', actionData.payload)
            const token = store.state.auth.token
            const response = await addNewCrmStatus(actionData.company.id, actionData.payload, token)
            handleActionResponse(response, actionData.buttonId, `${actionData.company.company_name} - ${actionData.company.id}: Error updating CRM status.`)
        }
    },
    updateCRMNextAction: {
        async performAction(actionData) {
            // console.log('performAction', actionData.payload)
            previousAction.value = actionData.company.crm_next_action
            crmNextAction.value = actionData.payload
            console.log('next action', crmNextAction.value)
            crmNextActionDueDate.value = actionData.company.crm_next_action_due_date
            displayedCompany.value = actionData.company
            if(actionData.company.campaign && previousAction.value && previousAction.value != 'None') {
                visibleCRMEventForm.value = true
                crmDetailData.action_id = getDetailIdFromNextAction(previousAction.value)
                crmDetailData.resolved_date = getTodaysDateAsString()
                crmDetailData.company_id = displayedCompany.value.id
                crmDetailData.campaign_id = displayedCompany.value.campaign ? displayedCompany.value.campaign.id : null
                newDetailFormData.action_id = getDetailIdFromNextAction(crmNextAction.value)
                newDetailFormData.due_date = getTodaysDateAsString()
                newDetailFormData.company_id = displayedCompany.value.id
                newDetailFormData.campaign_id = displayedCompany.value.campaign ? displayedCompany.value.campaign.id : null
            } else {
                await saveCRMNextActionWithoutEvent()
            }
        },
    },
    updateCRMNextActionDueDate: {
        async performAction(actionData) {
            // console.log('companyActionRows: updateCRMNextActionDueDate', actionData.payload)
            const token = store.state.auth.token
            const response = await updateCompany(actionData.company.id, actionData.payload, token)
            handleActionResponse(response, actionData.buttonId, `${actionData.company.company_name} - ${actionData.company.id}: Error updating CRM next action due date.`)
        }
    },
    openAllContacts: {
        performAction(actionData) {
            // console.log('companyActionRows: openAllContacts')
            displayedCompany.value = actionData.company
            visibleContactList.value = true
        }
    },
    markNoURL: {
        async performAction(actionData) {
            const token = store.state.auth.token
            const response = await vetURL(actionData.company.id, actionData.payload, token)
            handleActionResponse(response, actionData.buttonId, `${actionData.company.company_name} - ${actionData.company.id}: Error marking No URL.`)
        }
    },
    markURLVetted: {
       async  performAction(actionData) {
            const token = store.state.auth.token
            const response = await vetURL(actionData.company.id, actionData.payload, token)
            handleActionResponse(response, actionData.buttonId, `${actionData.company.company_name} - ${actionData.company.id}: Error marking URL vetted.`)
        }
    },
    removeURLVetted:{
       async performAction(actionData) {
            const token = store.state.auth.token
            const response = await vetURL(actionData.company.id, actionData.payload, token)
            handleActionResponse(response, actionData.buttonId, `${actionData.company.company_name} - ${actionData.company.id}: Error removing URL vetted.`)
        }
    }
})

const companySummaryActions = reactive({
    setCRMSummaries: {
        label: 'Load CRM Summary',
        buttonId: 'loadCRMStatusSummary',
        type: 'loading-button',
        crmStatuses: null,
        crmActions: null,
        crmSummaryStages: null,
        async performAction(actionData) {
            // console.log('companySummaryActions: setSummaries', actionData.payload)
            const token = store.state.auth.token
            const clientId = null
            const crmSummaryStagesResponse = await getCRMSummaryStageCounts(actionData.payload, token, clientId)
            this.crmSummaryStages = crmSummaryStagesResponse.data
            handleSummaryActionResponse(crmSummaryStagesResponse, actionData.buttonId, 'Error getting CRM Summary Stage Counts.')
            const crmSummaryResponse = await getCRMSummaries(actionData.payload, token)
            this.crmStatuses = crmSummaryResponse.data.crm_selections_dict
            this.crmActions = crmSummaryResponse.data.crm_next_actions_dict
            handleSummaryActionResponse(crmSummaryResponse, actionData.buttonId, 'Error getting CRM Status & Next Action Summaries.')
        }
    }
})


const columnSpan = computed(() => {
    let numHeaders = tableHeaders.value.length
    return menuOptions.selectAllHeader ? numHeaders + 1 : numHeaders
})

const collectionTags = computed(() => {
  return companyFilters.collectionTag.value
})

function clearSummaryActionData() {
    // console.log('CompanyPage: clearSummaryActionData')
    companySummaryActions.setCRMSummaries.crmStatuses = null
    companySummaryActions.setCRMSummaries.crmActions = null
    companySummaryActions.setCRMSummaries.crmSummaryStages = null
}

function handleSummaryActionResponse(response, buttonId, errorMessage) {
    // console.log(buttonId)
    // console.log(response)
    if(response.status == 200) {
        $toast.open({
            type: 'success',
            duration: 5000,
            message: response.data.status,
        })
        reloadCompanies()
    } else {
        $toast.open({
            type: 'error',
            duration: 5000,
            message: errorMessage
        })
    }
    summaryActionButtonId.value = buttonId
}

function handleActionResponse(response, buttonId, errorMessage) {
    // console.log(response)
    if(response.status == 200) {
        $toast.open({
            type: 'success',
            duration: 5000,
            message: response.data.status ? response.data.status : 'Successfully completed action.',
        })
        reloadCompanies()
    } else {
        $toast.open({
            type: 'error',
            duration: 5000,
            message: errorMessage
        })
    }
    actionButtonId.value = buttonId
}

function handleBulkActionResponse(actionData, response) {
    // console.log('handleResponse', response)
    if(response.status == 200) {
        $toast.open({
            message:`Completed bulk operation: ${actionData.label}`,
            type: 'success',
            duration: 3000
        })
        if(!actionData.keepSelected) {
            clearSelectedResults()
        }
        reloadCompanies()
        fetchAllOptions()
    } else {
        $toast.open({
            message: `Could not complete bulk operation: ${actionData.label}`,
            type: 'error',
            duration: 10000
        })
    }
    bulkOperationResponse.value = response
}

function clearSelectedResults() {
    // console.log('bulkAction - clearSelectedResults')
    shouldClearSelected.value = !shouldClearSelected.value
}

function reloadCompanies() {
    shouldReload.value = !shouldReload.value
}

function setFilters(updatedFilters) {
    companyFilters.companyName = updatedFilters.companyName;
    companyFilters.client = updatedFilters.client;
}

function clearFilter(filterKey) {
    if(filterKey.endsWith('.min')) {
        companyFilters[filterKey.replace('.min', '')].min.value = null
    } else if(filterKey.endsWith('.max')) {
            companyFilters[filterKey.replace('.max', '')].max.value = null
    } else if(Array.isArray(companyFilters[filterKey].value)){
        companyFilters[filterKey].value = []
    } else {
        companyFilters[filterKey].value = null
    }
}

function clearAllActiveFilters() {
    Object.keys(companyFilters).forEach((filterKey) => {
        if(companyFilters[filterKey].min || companyFilters[filterKey].max) {
            if(companyFilters[filterKey].min) {
                companyFilters[filterKey].min.value = null
            } 
            if(companyFilters[filterKey].max) {
                    companyFilters[filterKey].max.value = null
            }
        } else if(Array.isArray(companyFilters[filterKey].value)){
            companyFilters[filterKey].value = []
        } else {
            companyFilters[filterKey].value = null
        } 
    })
}

function closeContactList() {
    visibleContactList.value = false
    displayedCompany.value = null
}

function closeNewContactForm() {
    visibleNewContactForm.value = false
    displayedCompany.value = null
}

function closeEditForm() {
    visibleEditForm.value = false
    displayedCompany.value = null
}

function closeCRMDetails() {
    visibleCRMDetails.value = false
    defaultCampaignId.value = null
    displayedCompany.value = null
}

function closeCRMEventForm() {
    // console.log('closeCRMEventForm')
    visibleCRMEventForm.value = false
    clearFormData()
}

function closeCRMEventFormWithoutSaving() {
    // console.log('closeCRMEventFormWithoutSaving')
    visibleCRMEventForm.value = false
    toggleResetToPreviousCRMAction()
    clearFormData()
}

function toggleResetToPreviousCRMAction() {
    // console.log('resetToPreviousCRMAction', resetToPreviousCRMAction.value)
    resetToPreviousCRMAction.value = !resetToPreviousCRMAction.value
    // console.log(resetToPreviousCRMAction.value)
}

function clearFormData() {
    // console.log('clearFormData')
    displayedCompany.value = null
    previousAction.value = null
    crmNextAction.value = null
    crmDetailData.company_id = null
    crmDetailData.campaign_id = null
    newDetailFormData.company_id = null
    newDetailFormData.campaign_id = null
}

function getDetailIdFromNextAction(crmNextAction){
    if(crmNextAction == "Send Initial Email"){
        return 2
    }
    if(crmNextAction == "Send Another Email"){
        return 1
    }
    if(crmNextAction == "Call"){
        return 9
    }
    if(crmNextAction == "Send 2nd Email"){
        return 3
    }
    if(crmNextAction == "Send 3rd Email"){
        return 4
    }
    if(crmNextAction == "Send 4th Email"){
        return 21
    }
    if(crmNextAction == "Cold Call 1"){
        return 5
    }
    if(crmNextAction == "Cold Call 2"){
        return 5
    }
    if(crmNextAction == "Call Again"){
        return 5
    }
    if(crmNextAction == "Not Now"){
        return 25
    }
    if(crmNextAction == "Submit IOI"){
        return 15
    }
    if(crmNextAction == "Submit LOI"){
        return 16
    }
}

function setPinnedFilters(pinnedFilters) {
    pinnedFilters.forEach((pinnedFilter) => {
        let filterToPin = Object.values(companyFilters).find((filter) => filter.id == pinnedFilter.company_filter_field)
        if(filterToPin) {
            filterToPin.pinned = true
            filterToPin.persisted_id = pinnedFilter.id
            filterToPin.ordinal = parseFloat(pinnedFilter.ordinal)
        }
    })
    reorderFilters.value = !reorderFilters.value
}

function setPinnedBulkOperations(pinnedBulkOperations) {
    pinnedBulkOperations.forEach((pinnedBulkOperation) => {
        let bulkOperationToPin = Object.values(companyBulkOperations).find((bulkOperation) => bulkOperation.id == pinnedBulkOperation.company_bulk_operation_field)
        bulkOperationToPin.pinned = true
        bulkOperationToPin.persisted_id = pinnedBulkOperation.id
        bulkOperationToPin.ordinal = parseFloat(pinnedBulkOperation.ordinal)
    })
    reorderBulkOperations.value = !reorderBulkOperations.value
}

function setNextActionDueDate(timeDelta) {
    if(!timeDelta) {
       crmNextActionDueDate.value = getTodaysDateAsString()
    } else {
        let today = new Date()
        crmNextActionDueDate.value = getDateAsString(new Date(today.setDate(today.getDate() + timeDelta)))
    }

}

function setCRMDetailResolvedDate(timeDelta) {
    if(!timeDelta) {
       crmDetailData.resolved_date = getTodaysDateAsString()
    } else {
        let today = new Date()
        crmDetailData.resolved_date = getDateAsString(new Date(today.setDate(today.getDate() + timeDelta)))
    }

}

function setNewDetailFormDueDate(timeDelta) {
    if(!timeDelta) {
        newDetailFormData.due_date = getTodaysDateAsString()
    } else {
        let today = new Date()
        newDetailFormData.due_date = getDateAsString(new Date(today.setDate(today.getDate() + timeDelta)))
    }

}

watch(collectionTags, (newValue, oldValue)=> {
  if(!(collectionTags.value.length > 0)){
      companyFilters.collectionTagSources.value = []
  }
  if(newValue.length < oldValue.length){
      companyFilters.collectionTagSources.value = []
  }
})

watch(() => companyFilters.collectionTag.value.length, () => {
    if(companyFilters.collectionTag.value.length > 0) {
        companyFilters.collectionReview.visible = true
    } else {
        companyFilters.collectionReview.value = null
        companyFilters.collectionReview.visible = false
    }
})

watch(() => companyFilters.drivingTime.expression.value, () => {
    if(companyFilters && companyFilters.drivingTime.expression.value && companyFilters.drivingTime.expression.value == 'hours') {
        companyFilters.drivingTime.placeholder = '1.5 hours'
    } else {
        companyFilters.drivingTime.placeholder= '90 minutes'
    }
})

function performRowAction(actionData) {
    actionButtonId.value = null
    // console.log('CompanyPage: performRowAction', actionData)
    companyRowActions[actionData.actionKey].performAction(actionData)
}

function performSummaryAction(actionData) {
    summaryActionButtonId.value = null
    // console.log('CompanyPage: performSummaryAction', actionData)
    companySummaryActions[actionData.actionKey].performAction(actionData)
}

async function updateCRMDetailNotesFromEmailTemplate(bulkAction, templateID) {
    console.log('onUpdate', bulkAction, templateID)
    const token = store.state.auth.token
    const response = await getEmailTemplate(templateID, token)
    // let emailTemplate = bulkAction.inputs.emailTemplate.options.find((emailOption) => emailOption.value == templateValue)
    bulkAction.inputs.note.value = response.email_body
    bulkAction.inputs.emailTemplate.value = null
}   

async function saveCRMNextActionWithEvent() {
    const token = store.state.auth.token
    const data = JSON.stringify({
        crm_next_action: crmNextAction.value,
        crm_next_action_due_date: crmNextActionDueDate.value ? crmNextActionDueDate.value : null,
        event_data: completedAction.value ? crmDetailData : null,
        new_detail_data: newDetail.value ? newDetailFormData: null
    })
    const response = await updateCrmNextActionAndAddEvent(displayedCompany.value.id, data, token)
    handleActionResponse(response, null, `${displayedCompany.value.company_name} - ${displayedCompany.value.id}: Error updating CRM next action.`)
    closeCRMEventForm()
}
async function saveCRMNextActionWithoutEvent() {
    // console.log('saveCRMNextActionWithoutEvent')
    const token = store.state.auth.token
    const payload = JSON.stringify({
        crm_next_action: crmNextAction.value,
        crm_next_action_due_date: crmNextActionDueDate.value,
    })
    const response = await updateCrmNextAction(displayedCompany.value.id, payload, token)
    handleActionResponse(response, null, `${displayedCompany.value.company_name} - ${displayedCompany.value.id}: Error updating CRM next action.`)
    closeCRMEventForm()
}

async function setFilterOptions(filterName, queryParams='') {
    // console.log('CompanyPage: setFilterOptions', filterName)
    if(!companyFilters[filterName].awaitingOptions){
        if(companyFilters[filterName].setOptionsMethod){
            companyFilters[filterName].awaitingOptions = true
            companyFilters[filterName].setOptionsMethod(queryParams)
            setTimeout(() => {
                companyFilters[filterName].awaitingOptions = false;
            }, 30000)
        }
    }
}

async function loadClientOptions() {
    // console.log('loadClientOptions')
    const token = store.state.auth.token
    const response = await getClients({token: token, endpoint: '?get_all=true'})
    // console.log(response)
    clientOptions.value = response.data.map((client) => {
        return {value: client.id, label: client.client_name}
    })
    companyFilters.client.options = [{value: "clear", label: "------------"}, ...response.data.map((client) => {
        return {
            label: client.client_name, 
            value: client.id,
        }
    })];
}

async function loadSourceOptions() {
    // console.log('loadSourceOptions')
    const token = store.state.auth.token
    const response = await getSources(token)
    companyFilters.source.options = [{value: "clear", label: "------------"}, {value: "null", label: "Unassigned"}, ...response.map((source) => {
        return {value: source.id, label: source.source_name }
    })]
    companyFilters.sourceExclude.options = [{value: "clear", label: "------------"}, {value: "null", label: "Unassigned"}, ...response.map((source) => {
        return {value: source.id, label: source.source_name }
    })]
}

async function loadTierOptions() {
    // console.log('loadTierOptions')
    const token = store.state.auth.token
    const response = await getTiers(token)
    companyFilters.tier.options = [{value: "clear", label: "------------"}, {value: "unmarked", label: "None"}, ...response.map((tier) => {
        return {value: tier.id, label: tier.tier_name}
    })]
}

async function loadNAICSOptions() {
    // console.log('loadNAICSOptions')
    const token = store.state.auth.token
    const response = await getNAICSCodes(token)
    companyFilters.naics.options = [{value: "clear", label: "------------"}, ...response.map((naics) => {
        return {value: naics.id, label: `${naics.code} - ${naics.title}` }
    })]
}

async function loadDrivingTimeFocusOptions() {
    // console.log('loadDrivingTimeFocusOptions')
    const token = store.state.auth.token
    const response = await getGeoLocations(token)
    companyFilters.drivingTimeFocus.options = [{value: "clear", label: "------------"},...response.map((drivingTimeFocus) => {
        return {value: drivingTimeFocus.id, label: drivingTimeFocus.geo_location_name }
    })]
}

async function loadCollectionTagOptions() {
    // console.log('loadCollectionTagOptions')
    const token = store.state.auth.token
    const response = await getCollectionTags(token)
    companyFilters.collectionTag.options = [{value: "clear", label: "------------"}, ...response.map((collectionTag) => {
        return {value: collectionTag.id, label: collectionTag.collection_tag_name }
    })]
    companyFilters.collectionTagExclude.options = [{value: "clear", label: "------------"}, ...response.map((collectionTag) => {
        return {value: collectionTag.id, label: collectionTag.collection_tag_name }
    })]
    companyBulkOperations.assignAllToCollection.inputs.collectionTag.options = [{value: "clear", label: "------------"}, ...response.map((collectionTag) => {
        return {value: collectionTag.collection_tag_name, label: collectionTag.collection_tag_name }
    })]
    companyBulkOperations.assignToCollection.inputs.collectionTag.options = [{value: "clear", label: "------------"}, ...response.map((collectionTag) => {
        return {value: collectionTag.collection_tag_name, label: collectionTag.collection_tag_name }
    })]
    companyBulkOperations.removeFromCollection.inputs.collectionTag.options = [{value: "clear", label: "------------"}, ...response.map((collectionTag) => {
        return {value: collectionTag.collection_tag_name, label: collectionTag.collection_tag_name }
    })]
}

async function loadCampaignChangeRequestorOptions() {
    // console.log('loadCampaignChangeRequestorOptions')
    const token = store.state.auth.token
    const payload = {
        endpoint: "?has_campaign_change_requests=True",
        token: token
    }
    const response = await getUsers(payload)
    companyFilters.campaignChangeRequestor.options = [{value: null, label: "------------"}, ...response.users.map((user) => {
        return {value: user.id, label: `${user.first_name} ${user.last_name}`}
    })]
}

async function loadCollectionTagSourcesOptions(collectionTagIDs=null) {
    // console.log('loadCollectionTagSourcesOptions')
    let query = '?is_collection_tag_source=True'
    if(collectionTagIDs){
        for(const collectionTagID of collectionTagIDs){
        query += `&collection_tag=${collectionTagID}`
        }
    }
    let payload = {
        token: store.state.auth.token,
        endpoint: query
    }
    const response = await getAsynchronousJobQueue(payload)
    companyFilters.collectionTagSources.options = [{value: "clear", label: "------------"}, ...response.jobs.map((job) => {
        return {value: job.id, label: `${formatDateTime(job.created_at)} - ${job.job_title}`}
    })]
}

async function loadCRMStatusOptions() {
    // console.log('loadCRMStatusOptions')
    const token = store.state.auth.token
    const response = await getCrmStatuses(token)
    crmStatuses.value = response
    companyFilters.crmStatus.options = [{value: "clear", label: "------------"}, {value: "null", label: "Unassigned"}, ...response.map((status) => {
        return {value: status.id, label: status.status_name }
    })]
    companyFilters.crmStatusExclude.options = [{value: "clear", label: "------------"}, {value: "null", label: "Unassigned"}, ...response.map((status) => {
        return {value: status.id, label: status.status_name }
    })]
    companyBulkOperations.updateCRMStatus.inputs.crmStatus.options = [...response.map((status) => {
        return {value: status.id, label: status.status_name }
    })]
    crmStatusOptions.value = response.map((status) => {
        return {value: status.id, label: status.status_name }
    })
}

async function loadTaskUserOptions(){
    // console.log('loadTaskUserOptions')
    const token = store.state.auth.token
    const response = await getUsersWithTasks(token)
    companyFilters.taskUser.options = [{value: "clear", label: "------------"}, ...response.users.map((user) => {
        return {value: user.id, label: user.first_name + " " + user.last_name }
    })]
}

async function loadCampaignOptions() {
    // console.log('loadCampaignOptions')
    const token = store.state.auth.token
    const response = await getCampaigns(token)
    companyFilters.campaign.options = [{value: "clear", label: "------------"}, {value: "null", label: "Unassigned"}, ...response.filter((campaign) => campaign.status == 'active').map((campaign) => {
        return {value: campaign.id, label: campaign.campaign_name}
    })]
    companyFilters.previousCampaign.options = [{value: "clear", label: "------------"}, ...response.map((campaign) => {
        return {value: campaign.id, label: campaign.campaign_name}
    })]
    companyFilters.campaignExclude.options = [{value: "clear", label: "------------"}, ...response.filter((campaign) => campaign.status == 'active').map((campaign) => {
        return {value: campaign.id, label: campaign.campaign_name}
    })]
    companyBulkOperations.assignToCampaign.inputs.campaign.options = [{value: "null", label: "No Campaign"}, ...response.filter((campaign) => campaign.status == 'active').map((campaign) => {
        return {value: campaign.id, label: campaign.campaign_name}
    })]
    campaigns.value = response
}

async function loadReferralSourceOptions() {
    // console.log('loadReferralSourceOptions')
  const payload = {
      token: store.state.auth.token,
      endpoint: '?status=active'
  }
  const response = await getReferralSources(payload)
  companyFilters.referralSource.options = [{value: "clear", label: "------------"},...response.referrals.map((referralSource) => {
      return {value: referralSource.id, label: `${referralSource.referrer_first_name} ${referralSource.referrer_last_name} - ${referralSource.referrer_email}`}
  })]  
}

async function loadCompanies(fetchFilter='') {
    // console.log('loadCompanies')
    isLoading.value = true;
    const token = store.state.auth.token
    // response.value = await getResearchCompanies(token, fetchFilter);
    if(fetchFilter){
        fetchFilter = fetchFilter + '&is_private_equity=True'
    } else {
        fetchFilter = '?is_private_equity=True'
    }
    response.value = await getCompaniesByQueryParams(token, fetchFilter);
    if(displayedCompany.value) {
        displayedCompany.value = response.value.data.results.find((company) => company.id == displayedCompany.value.id)
    }
    // console.log(response.value)
    // categorizeDataRequestsByStatus(response.value.data)
    isLoading.value = false;
}

async function loadCRMUserOptions() {
    let payload = {
        token: store.state.auth.token,
        endpoint: '?group_id=1&group_id=7&group_id=8&exclude_dev=True'
    }
    const response = await getUsers(payload)
    crmUsers.value = response.users
    companyBulkOperations.addNewCRMDetail.inputs.user.options = [{value: null, label: 'No User'}, ...response.users.map((crmUser) => {
        return {label: `${crmUser.first_name} ${crmUser.last_name}`, value: crmUser.id}
    })]
    companyBulkOperations.createResearchAssignment.inputs.user.options = [{value: null, label: 'No User'}, ...response.users.map((crmUser) => {
        return {label: `${crmUser.first_name} ${crmUser.last_name}`, value: crmUser.id}
    })]
    companyBulkOperations.assignCrmSpreadsheetUsers.inputs.crmUsers.options = [...response.users.map((crmUser) => {
        return {label: `${crmUser.first_name} ${crmUser.last_name}`, value: crmUser.id}
    })]
}

async function loadCRMActionTypes() {
    const token = store.state.auth.token
    const response = await getActions(token)
    crmActionTypes.value = response.data
    companyBulkOperations.addNewCRMDetail.inputs.crmDetail.options = [{value: null, label: 'No Action'}, ...response.data.map((crmAction) => {
        return {value: crmAction.id, label: crmAction.action_name}
    })]
}

async function loadEmailTemplates() {
    const token = store.state.auth.token
    const response = await getEmailTemplates(token)
    companyBulkOperations.sendEmail.inputs.emailTemplate.options = response.map((template) => {
        return {value: template.id, data: template, label: `${template.email_template_name}${template.email_to ? `\nTo: ${template.email_to.email_address}` : ''}`}
    })
    // Prepare Outreach Drafts only supports templates whose from-address is
    // Entra-approved for direct (Graph) sending.
    companyBulkOperations.prepareDrafts.inputs.emailTemplate.options = response
        .filter((template) => template.email_from_new && template.email_from_new.available_for_outreach_drafts)
        .map((template) => {
            return {value: template.id, data: template, label: `${template.email_template_name}${template.email_from_new ? `\nfrom: ${template.email_from_new.email_address}` : ''}`}
        })
    companyBulkOperations.addNewCRMDetail.inputs.emailTemplate.options = response.map((template) => {
        return {value: template.id, data: template, label: `${template.email_template_name}${template.email_to ? `\nTo: ${template.email_to.email_address}` : ''}`}
    })
}

async function loadPinnedFilters() {
    // console.log('loadPinnedFilters')
    const token = store.state.auth.token
    const userId = store.state.auth.user.id
    const response = await getPinnedUserCompanyFilterFields(token, userId)
    // console.log(response)
    setPinnedFilters(response.data)
}

async function togglePinnedFilter(filterKey) {
    // console.log('togglePinnedFilter', filterKey)
    let pinnedValue = companyFilters[filterKey].pinned
    companyFilters[filterKey].pinned = !companyFilters[filterKey].pinned
    reorderFilters.value = !reorderFilters.value
    await persistFilterPinnedState(companyFilters[filterKey], !pinnedValue)
    loadPinnedFilters()
}

async function persistFilterPinnedState(filter, pinned) {
    // console.log('persistFilterPinnedState', filter, pinned)
    const token = store.state.auth.token
    const payload = JSON.stringify({
        company_filter_field_id: filter.id,
        pinned: pinned,
    })
    const response = await setPinnedUserCompanyFilterField(token, payload)
    // console.log(response)
}

async function saveFilterOrder() {
    console.log('saveFilterOrder')
    const token = store.state.auth.token
    const filterOrdinalPairsToUpdate = Object.values(companyFilters).filter((companyFilter) => companyFilter.persisted_id && companyFilter.persisted_id > 0).map((companyFilter) => { return {id: companyFilter.persisted_id, ordinal: companyFilter.ordinal}})
    const result = await updateFilterOrdinals(token, filterOrdinalPairsToUpdate)
    if(result.status == 200){
        return
    } else {
        $toast.open({
            message: "Error, could not reorder filters",
            type: "error",
            duration: 3000
        })
    }
}

async function saveBulkOperationOrder() {
    console.log('saveBulkOperationOrder')
    const token = store.state.auth.token
    const bulkOperationOrdinalPairsToUpdate = Object.values(companyBulkOperations).filter((companyBulkOperation) => companyBulkOperation.persisted_id && companyBulkOperation.persisted_id > 0).map((companyBulkOperation) => { return {id: companyBulkOperation.persisted_id, ordinal: companyBulkOperation.ordinal}})
    const result = await updateBulkOperationOrdinals(token, bulkOperationOrdinalPairsToUpdate)
    if(result.status == 200){
        return
    } else {
        $toast.open({
            message: "Error, could not reorder bulk operations",
            type: "error",
            duration: 3000
        })
    }
}

async function loadPinnedBulkOperations() {
    // console.log('loadPinnedBulkOperations')
    const token = store.state.auth.token
    const userId = store.state.auth.user.id
    const response = await getPinnedUserCompanyBulkOperationFields(token, userId)
    // console.log(response)
    setPinnedBulkOperations(response.data)
}

async function togglePinnedBulkOperation(bulkOperationKey) {
    // console.log('togglePinnedBulkOperation', bulkOperationKey)
    let pinnedValue = companyBulkOperations[bulkOperationKey].pinned
    companyBulkOperations[bulkOperationKey].pinned = !companyBulkOperations[bulkOperationKey].pinned
    reorderBulkOperations.value = !reorderBulkOperations.value
    if(pinnedValue) {
        await persistUnpinnedBulkOperation(companyBulkOperations[bulkOperationKey])
    } else {
        await persistPinnedBulkOperation(companyBulkOperations[bulkOperationKey])
    }
    loadPinnedBulkOperations()
}

async function persistPinnedBulkOperation(bulk_operation) {
    // console.log('persistPinnedBulkOperation', bulk_operation)
    const token = store.state.auth.token
    const payload = JSON.stringify({
        company_bulk_operation_field_id: bulk_operation.id,
        pinned: true,
    })
    const response = await createPinnedUserCompanyBulkOperationField(token, payload)
    // console.log(response)
}

async function persistUnpinnedBulkOperation(bulk_operation) {
    // console.log('persistUnpinnedBulkOperation', bulk_operation)
    const token = store.state.auth.token
    const response = await deletePinnedUserCompanyBulkOperationField(token, bulk_operation.persisted_id)
    // console.log(response)
}

async function handleBulkOperationInputChange(bulkAction, inputKey, inputValue) {
    await companyBulkOperations[bulkAction.key].inputs[inputKey].onUpdate(bulkAction, inputValue)
}

async function performCompanyBulkAction(bulkActionData) {
    // console.log('performCompanyBulkAction')
    // console.log(bulkActionData)
    if(bulkActionData.overrideAction) {
        companyBulkOperations[bulkActionData.key].performBulkAction(bulkActionData)
    } else {
        let response
        const token = store.state.auth.token
        if(bulkActionData.type == 'onSelected' && bulkActionData.selectedResults.length > 0) {
            const selectedResultIds = bulkActionData.selectedResults.map(({id}) => id)
            response = await performBulkAction(token, selectedResultIds, bulkActionData.endpoint, bulkActionData.payload)
        } else if (bulkActionData.type == 'onQuery' && bulkActionData.queryParams) {
            response = await performBulkActionOnQuery(token, bulkActionData.payload, bulkActionData.endpoint, bulkActionData.queryParams)
        }
        if(response) {
            handleBulkActionResponse(bulkActionData, response)
        }
    }
}

async function exportResultsToCSV(payload) {
    console.log('exportResultsToCSV', payload)
    const token = store.state.auth.token
    const fields = getCompanyFields()
    const response = await exportToCSV(payload, token, fields)
    if(response.status == 201) {
        $toast.open({
            type: 'success',
            duration: 5000,
            message: response.data.job_status,
        })
        createCSV(fields, response.data.companies, 'company')
    } else {
        $toast.open({
            type: 'error',
            duration: 5000,
            message: 'Could not export results to CSV.'
        })
    }
    
}

function fetchAllOptions() {
    loadClientOptions()
    loadSourceOptions()
    loadCampaignOptions()
    loadCampaignChangeRequestorOptions()
    loadCRMStatusOptions()
    loadCollectionTagOptions()
    loadEmailTemplates()
    loadCollectionTagSourcesOptions()
    loadDrivingTimeFocusOptions()
    loadNAICSOptions()
    loadReferralSourceOptions()
    loadTierOptions()
    loadTaskUserOptions()
    loadCRMUserOptions()
    loadCRMActionTypes()
    loadPinnedFilters()
    loadPinnedBulkOperations()
}
  
fetchAllOptions()
</script>